/* CELESTIAR — sky-creator.js : page « Créez votre ciel »
   - etoiles reelles visibles a l'oeil nu (mag <= 5,2, catalogue d3-celestial, MIT) : un ciel net et lisible
   - constellations + Soleil, Lune et 5 planetes (Schlyter)
   - Fuseau horaire exact (table ville + timeapi.io, repli heure solaire)
   - Bilingue : libelles lus dans les data-attributes du canvas */
(function () {
  "use strict";

  var CITIES = {
    paris: [48.8566, 2.3522, "Europe/Paris"], lyon: [45.764, 4.8357, "Europe/Paris"],
    bordeaux: [44.8378, -0.5792, "Europe/Paris"], marseille: [43.2965, 5.3698, "Europe/Paris"],
    lille: [50.6292, 3.0573, "Europe/Paris"], toulouse: [43.6047, 1.4442, "Europe/Paris"],
    nantes: [47.2184, -1.5536, "Europe/Paris"], nice: [43.7102, 7.262, "Europe/Paris"],
    strasbourg: [48.5734, 7.7521, "Europe/Paris"], montpellier: [43.6108, 3.8767, "Europe/Paris"],
    rennes: [48.1173, -1.6778, "Europe/Paris"], bruxelles: [50.8503, 4.3517, "Europe/Brussels"],
    geneve: [46.2044, 6.1432, "Europe/Zurich"], luxembourg: [49.6116, 6.1319, "Europe/Luxembourg"],
    montreal: [45.5017, -73.5673, "America/Toronto"], london: [51.5074, -0.1278, "Europe/London"],
    "new york": [40.7128, -74.006, "America/New_York"], tokyo: [35.6762, 139.6503, "Asia/Tokyo"],
    kyoto: [35.0116, 135.7681, "Asia/Tokyo"], sydney: [-33.8688, 151.2093, "Australia/Sydney"],
    "le caire": [30.0444, 31.2357, "Africa/Cairo"]
  };
  var geoCache = {};
  var rad = function (d) { return d * Math.PI / 180; };
  var deg = function (r) { return r * 180 / Math.PI; };

  function normalize(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").split(",")[0].trim();
  }

  var picked = {};
  function geocode(loc, fallbackLat, fallbackLng, fallbackTz, cb) {
    var key = normalize(loc);
    if (picked[loc]) {
      key = "__pick__" + loc;
      if (geoCache[key]) return cb(geoCache[key], true);
      var pk = picked[loc];
      return fetch("https://timeapi.io/api/timezone/coordinate?latitude=" + pk[0] + "&longitude=" + pk[1])
        .then(function (r) { return r.json(); })
        .then(function (tz) { var z = (tz && tz.timeZone) || null; if (z) geoCache[key] = { lat: pk[0], lng: pk[1], tz: z }; cb({ lat: pk[0], lng: pk[1], tz: z }, !!z); })
        .catch(function () { cb({ lat: pk[0], lng: pk[1], tz: null }, false); });
    }
    if (!key) return cb({ lat: fallbackLat, lng: fallbackLng, tz: fallbackTz }, false);
    if (CITIES[key]) return cb({ lat: CITIES[key][0], lng: CITIES[key][1], tz: CITIES[key][2] }, true);
    if (geoCache[key]) return cb(geoCache[key], true);
    var done = false;
    var fail = function () { if (!done) { done = true; cb({ lat: fallbackLat, lng: fallbackLng, tz: fallbackTz }, false); } };
    var timer = setTimeout(fail, 5000);
    fetch("https://nominatim.openstreetmap.org/search?q=" + encodeURIComponent(loc) + "&format=json&limit=1")
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (done || !res || !res[0]) return fail();
        var lat = parseFloat(res[0].lat), lng = parseFloat(res[0].lon);
        fetch("https://timeapi.io/api/timezone/coordinate?latitude=" + lat + "&longitude=" + lng)
          .then(function (r) { return r.json(); })
          .then(function (tz) {
            if (done) return; done = true; clearTimeout(timer);
            var zone = (tz && tz.timeZone) || null;
            geoCache[key] = { lat: lat, lng: lng, tz: zone };
            cb(geoCache[key], true);
          })
          .catch(function () {
            if (done) return; done = true; clearTimeout(timer);
            geoCache[key] = { lat: lat, lng: lng, tz: null };
            cb(geoCache[key], true);
          });
      })
      .catch(fail);
  }

  function zonedToUtc(y, mo, da, hh, mi, tz) {
    var target = Date.UTC(y, mo - 1, da, hh, mi);
    var guess = target;
    for (var i = 0; i < 2; i++) {
      var parts = new Intl.DateTimeFormat("en-US", {
        timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit",
        day: "2-digit", hour: "2-digit", minute: "2-digit"
      }).formatToParts(new Date(guess)).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
      var asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
      guess += target - asUtc;
    }
    return guess;
  }

  function lstHours(utcMs, lng) {
    var d2000 = utcMs / 86400000 - 10957.5;
    var gmst = 18.697374558 + 24.06570982441908 * d2000;
    return (((gmst % 24) + 24) % 24) + lng / 15;
  }

  function altAz(raDeg, decDeg, latDeg, lstH) {
    var ha = rad((lstH - raDeg / 15) * 15);
    var dec = rad(decDeg), lat = rad(latDeg);
    var alt = Math.asin(Math.sin(dec) * Math.sin(lat) + Math.cos(dec) * Math.cos(lat) * Math.cos(ha));
    var az = Math.atan2(Math.sin(ha), Math.cos(ha) * Math.sin(lat) - Math.tan(dec) * Math.cos(lat)) + Math.PI;
    return [deg(alt), az];
  }

  function project(alt, az, cx, cy, R) {
    var r = (90 - alt) / 90 * R;
    return [cx - r * Math.sin(az), cy - r * Math.cos(az)];
  }

  var ELEMS = {
    mercure: { N: [48.3313, 3.24587e-5], i: [7.0047, 5e-8], w: [29.1241, 1.01444e-5], a: 0.387098, e: [0.205635, 5.59e-10], M: [168.6562, 4.0923344368] },
    venus: { N: [76.6799, 2.4659e-5], i: [3.3946, 2.75e-8], w: [54.891, 1.38374e-5], a: 0.72333, e: [0.006773, -1.302e-9], M: [48.0052, 1.6021302244] },
    terre: { N: [0, 0], i: [0, 0], w: [282.9404, 4.70935e-5], a: 1.0, e: [0.016709, -1.151e-9], M: [356.047, 0.9856002585] },
    mars: { N: [49.5574, 2.11081e-5], i: [1.8497, -1.78e-8], w: [286.5016, 2.92961e-5], a: 1.523688, e: [0.093405, 2.516e-9], M: [18.6021, 0.5240207766] },
    jupiter: { N: [100.4542, 2.76854e-5], i: [1.303, -1.557e-7], w: [273.8777, 1.64505e-5], a: 5.20256, e: [0.048498, 4.469e-9], M: [19.895, 0.0830853001] },
    saturne: { N: [113.6634, 2.3898e-5], i: [2.4886, -1.081e-7], w: [339.3939, 2.97661e-5], a: 9.55475, e: [0.055546, -9.499e-9], M: [316.967, 0.0334442282] },
    lune: { N: [125.1228, -0.0529538083], i: [5.1454, 0], w: [318.0634, 0.1643573223], a: 60.2666, e: [0.0549, 0], M: [115.3654, 13.0649929509] }
  };

  function helio(el, d) {
    var N = rad(el.N[0] + el.N[1] * d), i = rad(el.i[0] + el.i[1] * d), w = rad(el.w[0] + el.w[1] * d);
    var e = el.e[0] + el.e[1] * d, M = rad((((el.M[0] + el.M[1] * d) % 360) + 360) % 360);
    var E = M + e * Math.sin(M) * (1 + e * Math.cos(M));
    for (var k = 0; k < 2; k++) E = E - (E - e * Math.sin(E) - M) / (1 - e * Math.cos(E));
    var xv = el.a * (Math.cos(E) - e), yv = el.a * Math.sqrt(1 - e * e) * Math.sin(E);
    var v = Math.atan2(yv, xv), r = Math.sqrt(xv * xv + yv * yv);
    var cw = Math.cos(v + w), sw = Math.sin(v + w);
    return [r * (Math.cos(N) * cw - Math.sin(N) * sw * Math.cos(i)),
            r * (Math.sin(N) * cw + Math.cos(N) * sw * Math.cos(i)),
            r * sw * Math.sin(i)];
  }

  function solarSystem(utcMs) {
    var d = utcMs / 86400000 - 10956;
    var ecl = rad(23.4393 - 3.563e-7 * d);
    var terre = helio(ELEMS.terre, d);
    var out = [];
    function pushRADec(name, xg, yg, zg, type) {
      var lon = Math.atan2(yg, xg), lat = Math.atan2(zg, Math.sqrt(xg * xg + yg * yg));
      var x = Math.cos(lon) * Math.cos(lat), y = Math.sin(lon) * Math.cos(lat), z = Math.sin(lat);
      var yge = y * Math.cos(ecl) - z * Math.sin(ecl);
      var zge = y * Math.sin(ecl) + z * Math.cos(ecl);
      out.push({ name: name, type: type, ra: ((deg(Math.atan2(yge, x)) % 360) + 360) % 360, dec: deg(Math.atan2(zge, Math.sqrt(x * x + yge * yge))) });
    }
    ["mercure", "venus", "mars", "jupiter", "saturne"].forEach(function (n) {
      var h = helio(ELEMS[n], d);
      pushRADec(n, h[0] + terre[0], h[1] + terre[1], h[2] + terre[2], "planete");
    });
    var l = helio(ELEMS.lune, d);
    pushRADec("lune", l[0], l[1], l[2], "lune");
    pushRADec("soleil", terre[0], terre[1], terre[2], "soleil");
    return out;
  }

  function allStars() {
    var base = (window.SKYDATA && window.SKYDATA.stars) || [];
    var extra = window.SKYDATA_EXTRA || [];
    return base.concat(extra);
  }

  /* ---- Signes du zodiaque : vraie constellation du signe (positions reelles J2000, AD en degres, Dec, magnitude) ---- */
  var ZODIAC = {
    belier: { sym: "\u2648", fr: "Bélier", en: "Aries", fig: { p: [[31.79,23.46,2],[28.66,20.81,2.6],[28.38,19.29,3.9],[42.5,27.26,3.6]], l: [[3,0],[0,1],[1,2]] } },
    taureau: { sym: "\u2649", fr: "Taureau", en: "Taurus", fig: { p: [[68.98,16.51,0.9],[67.17,15.87,3.4],[64.95,15.63,3.6],[65.73,17.54,3.8],[67.15,19.18,3.5],[60.17,12.49,3.4],[84.41,21.14,3],[81.57,28.61,1.6],[56.87,24.11,2.9]], l: [[5,2],[2,1],[1,0],[0,6],[2,3],[3,4],[4,7]] } },
    gemeaux: { sym: "\u264A", fr: "Gémeaux", en: "Gemini", fig: { p: [[113.65,31.89,1.6],[116.33,28.03,1.2],[99.43,16.4,1.9],[100.98,25.13,3.1],[95.74,22.51,2.9],[93.72,22.51,3.3],[110.03,21.98,3.5],[106.03,20.57,4],[107.78,30.25,4.4],[116.11,24.4,3.6]], l: [[0,8],[8,3],[3,4],[4,5],[1,6],[6,7],[7,2],[1,9]] } },
    cancer: { sym: "\u264B", fr: "Cancer", en: "Cancer", fig: { p: [[134.62,11.86,4.3],[124.13,9.19,3.5],[131.17,18.15,3.9],[130.82,21.47,4.7],[131.67,28.76,4]], l: [[1,2],[2,3],[3,4],[2,0]] } },
    lion: { sym: "\u264C", fr: "Lion", en: "Leo", fig: { p: [[152.09,11.97,1.4],[151.83,16.76,3.5],[154.99,19.84,2],[154.17,23.42,3.4],[148.19,26.01,3.9],[146.46,23.77,3],[168.53,20.52,2.6],[177.26,14.57,2.1],[168.56,15.43,3.3]], l: [[5,4],[4,3],[3,2],[2,1],[1,0],[2,6],[6,7],[7,8],[8,6],[0,8]] } },
    vierge: { sym: "\u264D", fr: "Vierge", en: "Virgo", fig: { p: [[201.3,-11.16,1],[190.41,-1.45,2.7],[195.54,10.96,2.9],[193.9,3.4,3.4],[177.67,1.76,3.6],[184.98,-0.67,3.9],[203.67,-0.6,3.4],[214,-6,4.1],[220.76,-5.66,3.9]], l: [[4,5],[5,1],[1,3],[3,2],[1,6],[6,0],[6,7],[7,8]] } },
    balance: { sym: "\u264E", fr: "Balance", en: "Libra", fig: { p: [[222.72,-16.04,2.8],[229.25,-9.38,2.6],[233.88,-14.79,3.9],[226.02,-25.28,3.3]], l: [[0,1],[1,2],[2,0],[0,3]] } },
    scorpion: { sym: "\u264F", fr: "Scorpion", en: "Scorpio", fig: { p: [[247.35,-26.43,1.1],[245.3,-25.59,2.9],[248.97,-28.22,2.8],[241.36,-19.8,2.6],[240.08,-22.62,2.3],[239.71,-26.11,2.9],[252.54,-34.29,2.3],[252.97,-38.05,3],[253.5,-42.36,4.7],[258.04,-43.24,3.3],[264.33,-43,1.9],[266.9,-40.13,3],[265.62,-39.03,2.4],[263.4,-37.1,1.6],[262.69,-37.3,2.7]], l: [[3,4],[4,5],[4,1],[1,0],[0,2],[2,6],[6,7],[7,8],[8,9],[9,10],[10,11],[11,12],[12,13],[13,14]] } },
    sagittaire: { sym: "\u2650", fr: "Sagittaire", en: "Sagittarius", fig: { p: [[271.45,-30.42,3],[275.25,-29.83,2.7],[276.99,-25.42,2.8],[281.41,-26.99,3.2],[283.82,-26.3,2],[285.65,-29.88,2.6],[286.74,-27.67,3.3],[276.04,-34.38,1.8]], l: [[0,1],[1,2],[2,3],[3,4],[4,6],[6,5],[5,7],[7,1],[3,5]] } },
    capricorne: { sym: "\u2651", fr: "Capricorne", en: "Capricorn", fig: { p: [[304.51,-12.54,3.6],[305.25,-14.78,3],[311.52,-25.27,4.1],[312.95,-26.92,4.1],[321.67,-22.41,3.8],[326.76,-16.13,2.9],[325.02,-16.66,3.7],[320.56,-16.83,4.3],[316.49,-17.23,4.1]], l: [[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,0]] } },
    verseau: { sym: "\u2652", fr: "Verseau", en: "Aquarius", fig: { p: [[311.92,-9.5,3.8],[322.89,-5.57,2.9],[331.45,-0.32,3],[335.41,-1.39,3.9],[337.21,-0.02,3.6],[338.84,-0.12,4],[343.15,-7.58,3.7],[342.4,-13.59,4],[343.66,-15.82,3.3]], l: [[0,1],[1,2],[2,3],[3,4],[4,5],[4,6],[6,7],[7,8]] } },
    poissons: { sym: "\u2653", fr: "Poissons", en: "Pisces", fig: { p: [[30.51,2.76,3.8],[25.36,5.49,4.5],[22.55,6.14,4.8],[18.43,7.58,5.2],[15.74,7.89,4.3],[12.17,7.58,4.4],[359.83,6.86,4],[354.99,5.63,4.1],[351.99,6.38,4.3],[349.29,3.28,3.7],[351.73,1.26,5],[355.51,1.78,4.5],[26.35,9.16,4.3],[22.87,15.35,3.6]], l: [[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,9],[9,10],[10,11],[11,7],[1,12],[12,13]] } }
  };
  function zodiacFor(dateStr, lang) {
    if (!dateStr) return null;
    var p = String(dateStr).split("-"), mo = +p[1], da = +p[2];
    if (!mo || !da) return null;
    var md = mo * 100 + da, k;
    if (md >= 1222 || md <= 119) k = "capricorne";
    else if (md <= 218) k = "verseau"; else if (md <= 320) k = "poissons";
    else if (md <= 419) k = "belier"; else if (md <= 520) k = "taureau";
    else if (md <= 620) k = "gemeaux"; else if (md <= 722) k = "cancer";
    else if (md <= 822) k = "lion"; else if (md <= 922) k = "vierge";
    else if (md <= 1022) k = "balance"; else if (md <= 1121) k = "scorpion";
    else k = "sagittaire";
    var Z = ZODIAC[k];
    return { key: k, sym: Z.sym, name: (lang === "en" ? Z.en : Z.fr), fig: Z.fig };
  }
  function drawZodiacEmblem(c, cx, cy, R, sign, acc) {
    var P = sign.fig.p, i, j;
    var wrap = function (d) { d = ((d + 540) % 360) - 180; return d; };
    var minRa = 1e9, maxRa = -1e9, minDe = 1e9, maxDe = -1e9, ra0 = P[0][0];
    P.forEach(function (s) { var r = wrap(s[0] - ra0); minRa = Math.min(minRa, r); maxRa = Math.max(maxRa, r); minDe = Math.min(minDe, s[1]); maxDe = Math.max(maxDe, s[1]); });
    var mRa = ra0 + (minRa + maxRa) / 2, mDe = (minDe + maxDe) / 2, k = Math.cos(rad(mDe));
    var w = Math.max((maxRa - minRa) * k, 1), h = Math.max(maxDe - minDe, 1);
    var S = Math.min(R * 1.5 / w, R * 1.18 / h);
    var oy = -R * 0.07;
    var X = function (ra) { return cx - wrap(ra - mRa) * k * S; };
    var Y = function (de) { return cy + oy - (de - mDe) * S; };
    /* Le vrai ciel reste entierement visible : aucun voile, aucun champ d'etoiles ajoute. La constellation du signe se pose
       par-dessus, en traits fins, avec un tout petit halo sombre pour rester lisible sur la Voie lactee. */
    c.save();
    c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.clip();
    c.strokeStyle = acc; c.lineWidth = Math.max(1.4, R * 0.006);
    c.lineCap = "round"; c.lineJoin = "round"; c.globalAlpha = 0.95;
    c.shadowColor = "rgba(0,0,0,0.85)"; c.shadowBlur = Math.max(3, R * 0.02);
    sign.fig.l.forEach(function (seg) {
      var a = P[seg[0]], b = P[seg[1]];
      c.beginPath(); c.moveTo(X(a[0]), Y(a[1])); c.lineTo(X(b[0]), Y(b[1])); c.stroke();
    });
    c.globalAlpha = 1;
    /* etoiles de la figure : points nets, plus gros pour les plus brillantes */
    P.forEach(function (st) {
      var x = X(st[0]), y = Y(st[1]), mag = st[2];
      var r = R * (0.008 + Math.max(0, 4.8 - mag) * 0.0035);
      c.fillStyle = "#FFFFFF"; c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fill();
      if (mag < 2.6) { c.strokeStyle = acc; c.lineWidth = Math.max(1, R * 0.003); c.beginPath(); c.arc(x, y, r * 2.1, 0, Math.PI * 2); c.stroke(); }
    });
    c.restore();
  }

  /* ---- Declinaisons de couleurs du ciel (meme dessin, autre teinte) ----
     etoile = le modele valide : fond noir, anneau et etoiles blancs, Voie lactee bleue. */
  var LOOKS = {
    etoile: { bg: "#000000", disk: "#000000", ring: "#FFFFFF", star: "255,255,255", line: "rgba(255,255,255,0.62)" },
    or: { bg: "#050505", disk: "#050505", ring: "#E2BE6A", star: "246,224,160", line: "rgba(228,196,120,0.8)", foil: ["#F8E6AE", "#DDB55A", "#A97F2C"] },
    argent: { bg: "#050506", disk: "#050506", ring: "#DDE1E8", star: "236,240,248", line: "rgba(222,228,238,0.74)", foil: ["#FFFFFF", "#D2D7E0", "#8F96A5"] },
    rose: { bg: "#070506", disk: "#070506", ring: "#EDB9B6", star: "252,226,224", line: "rgba(240,190,188,0.76)", foil: ["#FCE3E1", "#E3A9A6", "#B7787B"] },
    nuit: { bg: "#01040F", disk: "#020A26", ring: "#C4D4F7", star: "222,234,255", line: "rgba(176,202,248,0.6)" },
    cuivre: { bg: "#070504", disk: "#070504", ring: "#E39A6C", star: "250,208,172", line: "rgba(232,160,110,0.78)", foil: ["#F8D2B0", "#E0925F", "#9A5530"] },
    emeraude: { bg: "#030706", disk: "#030706", ring: "#86E6BD", star: "214,255,236", line: "rgba(130,225,185,0.74)", foil: ["#DDFFEF", "#74D9AB", "#2F936E"] },
    amethyste: { bg: "#060409", disk: "#060409", ring: "#CDB1FF", star: "240,230,255", line: "rgba(196,170,250,0.74)", foil: ["#F4EAFF", "#BD9DF7", "#7656C4"] },
    glacier: { bg: "#030609", disk: "#030609", ring: "#B2E5FF", star: "236,249,255", line: "rgba(160,218,248,0.74)", foil: ["#F4FCFF", "#A4DAF6", "#4F9AC6"] },
    rubis: { bg: "#080305", disk: "#080305", ring: "#FF9BAD", star: "255,224,230", line: "rgba(250,130,150,0.76)", foil: ["#FFD6DD", "#F4627D", "#A4213D"] }
  };
  /* Version « ciel blanc » : memes constellations, tracees en couleur sur le papier clair (pas de disque sombre) */
  var LOOKS_LIGHT = {
    etoile: { bg: "#F7F3E8", ring: "#2A2D36", star: "42,45,54", line: "rgba(42,45,54,0.62)" },
    or: { bg: "#F7F3E8", ring: "#B48B34", star: "170,128,44", line: "rgba(172,130,46,0.82)", foil: ["#D9B65E", "#B48B34", "#7E5D1C"] },
    argent: { bg: "#F7F3E8", ring: "#7C8290", star: "104,110,124", line: "rgba(104,110,124,0.74)", foil: ["#9AA1B0", "#737A89", "#4E5565"] },
    rose: { bg: "#F7F3E8", ring: "#B5787D", star: "170,104,110", line: "rgba(176,108,114,0.78)", foil: ["#D79AA0", "#B5787D", "#8E5559"] },
    nuit: { bg: "#F7F3E8", ring: "#26407E", star: "36,62,124", line: "rgba(38,64,126,0.74)" },
    cuivre: { bg: "#F7F3E8", ring: "#B2683E", star: "168,100,60", line: "rgba(172,104,62,0.8)", foil: ["#DCA27A", "#B2683E", "#7C4524"] },
    emeraude: { bg: "#F7F3E8", ring: "#2F8A66", star: "40,128,94", line: "rgba(44,134,98,0.78)", foil: ["#6CC6A1", "#2F8A66", "#1B5F45"] },
    amethyste: { bg: "#F7F3E8", ring: "#6B49B8", star: "104,72,178", line: "rgba(108,76,184,0.78)", foil: ["#A98CE6", "#6B49B8", "#46308A"] },
    glacier: { bg: "#F7F3E8", ring: "#3A86B0", star: "52,128,170", line: "rgba(58,134,176,0.78)", foil: ["#78BCE0", "#3A86B0", "#25618A"] },
    rubis: { bg: "#F7F3E8", ring: "#B02848", star: "172,38,70", line: "rgba(176,42,74,0.78)", foil: ["#E0728A", "#B02848", "#7E1B33"] }
  };
  function getLook(look, sky) { return sky === "blanc" ? (LOOKS_LIGHT[look] || LOOKS_LIGHT.etoile) : (LOOKS[look] || LOOKS.etoile); }

  function draw(canvas, opts, onDone) {
    if (!window.SKYDATA) return;
    var lang = (document.documentElement.lang || "fr").slice(0, 2);
    var dateLocale = lang === "en" ? "en-GB" : "fr-FR";
    var lblReal = canvas.dataset.labelReal || "POSITION RÉELLE DES ÉTOILES";
    var lblApprox = canvas.dataset.labelApprox || (lblReal + " · LIEU APPROXIMÉ");
    geocode(opts.location, 48.8566, 2.3522, "Europe/Paris", function (coords, precise) {
      var dateStr = opts.date || new Date().toISOString().slice(0, 10);
      var p = dateStr.split("-"), t = (opts.time || "22:00").split(":");
      var utcMs = coords.tz
        ? zonedToUtc(+p[0], +p[1], +p[2], +t[0] || 22, +t[1] || 0, coords.tz)
        : Date.UTC(+p[0], +p[1] - 1, +p[2], (+t[0] || 22), +t[1] || 0) - coords.lng * 240000;
      var lstH = lstHours(utcMs, coords.lng);
      var ctx = canvas.getContext("2d");
      var size = canvas.width;
      var LK = getLook(opts.look, opts.sky);
      var GOLD = LK.ring, GOLD_M = LK.ring, STAR = LK.star, light = opts.sky === "blanc";

      /* ciel blanc : fond transparent (le papier de l'affiche reste visible), l'apercu prend la couleur du papier en CSS */
      if (light) { ctx.clearRect(0, 0, size, size); canvas.style.background = LK.bg; }
      else { canvas.style.background = ""; ctx.fillStyle = LK.bg; ctx.fillRect(0, 0, size, size); }

      var cx = size / 2, cy = size * 0.46, R = size * 0.36;
      /* feuille d'or / d'argent : degrade metallique en diagonale sur tout le disque */
      var foil = null;
      if (LK.foil) {
        foil = ctx.createLinearGradient(cx - R, cy - R, cx + R, cy + R);
        foil.addColorStop(0, LK.foil[0]); foil.addColorStop(0.5, LK.foil[1]); foil.addColorStop(1, LK.foil[2]);
      }
      /* disque : noir profond, comme le modele */
      if (!light) {
        var diskFill = LK.disk;
        if (opts.sky === "bleu") {
          /* ciel bleu des mockups : bleu roi profond, leger degrade du centre vers le bord */
          diskFill = ctx.createRadialGradient(cx - R * 0.18, cy - R * 0.22, 0, cx, cy, R * 1.05);
          diskFill.addColorStop(0, "#0B2468"); diskFill.addColorStop(0.55, "#07194D"); diskFill.addColorStop(1, "#040F33");
        }
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.fillStyle = diskFill; ctx.fill();
      }
      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.clip();

      /* Constellations : traits fins et nets */
      var lineMode = opts.lines || "fins", magLimit = ({ legere: 4.6, normale: 5.6, riche: 6.6 })[opts.dens || "normale"] || 5.6;
      ctx.strokeStyle = foil || LK.line; ctx.globalAlpha = foil ? (lineMode === "marques" ? 1 : 0.82) : 1; ctx.lineWidth = Math.max(1.1, size / 850) * (lineMode === "marques" ? 1.9 : 1); ctx.lineJoin = "round"; ctx.lineCap = "round";
      (lineMode === "aucun" ? [] : window.SKYDATA.lines).forEach(function (poly) {
        ctx.beginPath();
        var pen = false;
        poly.forEach(function (pt) {
          var aa = altAz(360 - pt[0], pt[1], coords.lat, lstH);
          if (aa[0] < 1) { pen = false; return; }
          var xy = project(aa[0], aa[1], cx, cy, R);
          if (pen) ctx.lineTo(xy[0], xy[1]); else ctx.moveTo(xy[0], xy[1]);
          pen = true;
        });
        ctx.stroke();
      });
      ctx.globalAlpha = 1;

      /* Etoiles visibles a l'oeil nu (mag <= 5,6) : points nets, plus gros pour les plus brillantes */
      allStars().forEach(function (s) {
        var mag = s[2];
        if (mag > magLimit) return;
        var aa = altAz(360 - s[0], s[1], coords.lat, lstH);
        if (aa[0] < 0) return;
        var xy = project(aa[0], aa[1], cx, cy, R);
        var f = Math.max(0.2, 6.1 - mag);
        var radPx = size * (0.0007 + 0.0006 * Math.pow(f, 1.25));
        var sa = Math.min(1, Math.max(0.72, 1.3 - mag / 7));
        if (foil) { ctx.fillStyle = foil; ctx.globalAlpha = sa; } else ctx.fillStyle = "rgba(" + STAR + "," + sa.toFixed(2) + ")";
        ctx.beginPath(); ctx.arc(xy[0], xy[1], radPx, 0, Math.PI * 2); ctx.fill();
      });
      ctx.globalAlpha = 1;

      /* Soleil, Lune, planetes : petit cercle + point, comme sur le tirage */
      solarSystem(utcMs).forEach(function (b) {
        var aa = altAz(b.ra, b.dec, coords.lat, lstH);
        if (aa[0] < -1) return;
        var xy = project(Math.max(aa[0], 0), aa[1], cx, cy, R);
        var big = b.type === "lune" || b.type === "soleil";
        ctx.strokeStyle = foil || (light ? "rgba(" + STAR + ",0.9)" : "rgba(225,228,236,0.9)"); ctx.lineWidth = Math.max(1, size / 950);
        ctx.beginPath(); ctx.arc(xy[0], xy[1], size / (big ? 95 : 120), 0, Math.PI * 2); ctx.stroke();
        ctx.fillStyle = foil || (light ? "rgb(" + STAR + ")" : (b.type === "lune" ? "#EDE6CF" : "#E4E8F2"));
        ctx.beginPath(); ctx.arc(xy[0], xy[1], size / (big ? 210 : 330), 0, Math.PI * 2); ctx.fill();
      });
      ctx.restore();

      /* Anneau fin : un seul trait net, entierement a l'interieur du disque */
      var ringW = Math.max(2, size * 0.003);
      ctx.strokeStyle = foil || LK.ring; ctx.lineWidth = ringW;
      ctx.beginPath(); ctx.arc(cx, cy, R - ringW / 2, 0, Math.PI * 2); ctx.stroke();

      var east = lang === "en" ? "E" : "E", west = lang === "en" ? "W" : "O";
      ctx.fillStyle = GOLD; ctx.font = size / 58 + 'px "JetBrains Mono", monospace';
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      [["N", 0, -1], [east, -1, 0], ["S", 0, 1], [west, 1, 0]].forEach(function (c4) {
        ctx.fillText(c4[0], cx + R * 1.1 * c4[1], cy + R * 1.1 * c4[2]);
      });

      var loc = (opts.location || (lang === "en" ? "Paris, France" : "Paris, France")).toUpperCase();
      var d = new Date(dateStr + "T00:00:00");
      var dateLbl = isNaN(d) ? "" : d.toLocaleDateString(dateLocale, { day: "numeric", month: "long", year: "numeric" }).toUpperCase();
      ctx.fillStyle = GOLD_M; ctx.font = size / 64 + 'px "JetBrains Mono", monospace';
      ctx.fillText(precise ? lblReal : lblApprox, size / 2, size * 0.885);
      ctx.strokeStyle = "rgba(212,175,55,0.6)"; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(size * 0.36, size * 0.905); ctx.lineTo(size * 0.64, size * 0.905); ctx.stroke();
      ctx.fillStyle = GOLD; ctx.font = size / 44 + 'px "Cormorant Garamond", serif';
      ctx.fillText(loc + (dateLbl ? " · " + dateLbl : "") + (opts.time ? " · " + opts.time : ""), size / 2, size * 0.935);
      if (typeof onDone === "function") onDone(coords, precise);
    });
  }

  window.CelestiarSky = { draw: draw, pick: function (name, lat, lng) { picked[name] = [lat, lng]; } };

  /* ---------- Page « Créez votre ciel » : parcours complet 5 étapes ---------- */
  function init() {
    var canvas = document.querySelector("[data-sky-creator-canvas]");
    if (!canvas) return;
    var posterCanvas = document.querySelector("[data-sky-poster-canvas]");
    var frameWrap = document.querySelector("[data-sky-final-frame]");
    var box = canvas.parentElement;
    var size = Math.min(1600, Math.max(720, Math.floor((box.offsetWidth || 800) * (window.devicePixelRatio || 1))));
    canvas.width = size; canvas.height = size;

    var dateI = document.querySelector("[data-sky-date]");
    var timeI = document.querySelector("[data-sky-time]");
    var locI = document.querySelector("[data-sky-location]");
    var prenomI = document.querySelector("[data-sky-prenom]");
    var phraseI = document.querySelector("[data-sky-phrase]");
    var phraseCounter = document.querySelector("[data-sky-phrase-counter]");
    var shareBtn = document.querySelector("[data-sky-share]");
    var addBtn = document.querySelector("[data-sky-add]");
    var addLabel = document.querySelector("[data-sky-add-label]");
    var spellingI = document.querySelector("[data-sky-spelling]");
    var brandI = document.querySelector("[data-sky-brand]");
    var headI = document.querySelector("[data-sky-head]");
    var coordI = document.querySelector("[data-sky-coords]");
    var errorEl = document.querySelector("[data-sky-error]");

    var lang = (document.documentElement.lang || "fr").slice(0, 2);
    var dateLocale = lang === "en" ? "en-GB" : "fr-FR";

    var style = { shape: "cercle", bg: "noir", palette: "or", sky: "noir", finish: "laque", font: "elegance", layout: "classique", border: "fin", dens: "normale", lines: "fins", datefmt: "texte" };
    var state = {
      size: "30 × 40 cm",
      frame: "noir",
      support: "cadre",
      posterVariants: [],
      variantId: null,
      product: null,
      priceCents: null,
      variants: [],
      coords: null,
      skyReady: false
    };


    var money = function (cents) {
      return new Intl.NumberFormat(dateLocale, { style: "currency", currency: "EUR" }).format((cents || 0) / 100);
    };
    var fmtDate = function (v) {
      if (!v) return "";
      var d = new Date(v + "T00:00:00");
      return isNaN(d) ? "" : d.toLocaleDateString(dateLocale, { day: "numeric", month: "long", year: "numeric" });
    };

    /* --- Variantes Shopify (taille + cadre) ---
       Produit : ?produit=<handle>, sinon le produit dédié « Créez votre ciel ».
       La variante est retrouvée par produit + taille + cadre (noms d'options « Taille » / « Cadre »),
       jamais par identifiant écrit en dur ni par repli sur un autre cadre. */
    var cleanHandle = function (h) { return String(h || "").toLowerCase().replace(/[^a-z0-9\-]/g, ""); };
    var sectionEl = document.querySelector("[data-sky-handle]");
    var wantedHandle = cleanHandle(sectionEl && sectionEl.getAttribute("data-sky-handle")) || "creez-votre-ciel";
    var normFrame = function (s) {
      var c = String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return c.indexOf("chene") > -1 ? "chene" : (c.indexOf("blanc") > -1 ? "blanc" : (c.indexOf("noir") > -1 ? "noir" : c));
    };
    var normSize = function (s) { return String(s || "").toLowerCase().replace(/\s+/g, "").replace(/[x×]/g, "x"); };
    var loadProduct = function (h) {
      return fetch("/products/" + h + ".js").then(function (r) { if (!r.ok) throw new Error("product"); return r.json(); });
    };
    loadProduct(wantedHandle)
      .then(function (p) {
        state.product = p;
        state.variants = (p && p.variants) || [];
        syncVariant();
      }).catch(function () { syncVariant(); });

    /* Poster seul : proposé seulement si le produit « <handle>-poster-seul » est publié (sinon le choix reste masqué). */
    var supportBox = document.querySelector("[data-sky-support]");
    var framesWrap = document.querySelector("[data-sky-frames-wrap]");
    loadProduct(wantedHandle + "-poster-seul")
      .then(function (p) {
        state.posterVariants = (p && p.variants) || [];
        if (state.posterVariants.length && supportBox) supportBox.hidden = false;
      }).catch(function () {});
    /* « 21 × 30 cm » du cadre correspond à l'A4 du poster seul */
    var posterMatch = function (opt, size) {
      var o = normSize(opt), s = normSize(size);
      return s === "21x30cm" ? o.indexOf("21x29,7") === 0 : o === s;
    };
    document.querySelectorAll("[data-support]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll("[data-support]").forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        state.support = btn.dataset.support;
        var poster = state.support === "poster";
        if (framesWrap) framesWrap.hidden = poster;
        document.querySelectorAll("[data-size]").forEach(function (b) {
          var only = b.hasAttribute("data-poster-only");
          b.hidden = only ? !poster : false;
        });
        var cur = document.querySelector('[data-size="' + state.size + '"]');
        if (cur && cur.hidden) { var rec = document.querySelector('[data-size="30 × 40 cm"]'); if (rec) rec.click(); }
        if (frameWrap) frameWrap.setAttribute("data-sky-final-frame", poster ? "aucun" : state.frame);
        syncVariant();
      });
    });

    function optionIndex(names, fallback) {
      var opts = (state.product && state.product.options) || [];
      for (var i = 0; i < opts.length; i++) {
        var n = String((opts[i] && opts[i].name) || opts[i] || "").toLowerCase();
        for (var j = 0; j < names.length; j++) if (n.indexOf(names[j]) > -1) return i;
      }
      return fallback;
    }

    function syncVariant() {
      var si = optionIndex(["taille", "size", "format"], 0);
      var fi = optionIndex(["cadre", "frame"], 1);
      var v = state.support === "poster"
        ? state.posterVariants.find(function (x) { return posterMatch(x.option1, state.size); })
        : state.variants.find(function (x) {
          var o = x.options || [x.option1, x.option2, x.option3];
          return normSize(o[si]) === normSize(state.size) && normFrame(o[fi]) === state.frame;
        });
      state.variantId = v && v.available !== false ? v.id : null;
      state.priceCents = v ? v.price : null;
      if (addBtn) addBtn.setAttribute("data-combo-blocked", state.variantId ? "" : "1");
      updatePrice();
      if (window.celestiarRevalidate) window.celestiarRevalidate();
    }

    function updatePrice() {
      if (addLabel && state.priceCents == null) {
        addLabel.textContent = (window.CELESTIAR_I18N && window.CELESTIAR_I18N.not_found) || (lang === "en" ? "Combination unavailable" : "Combinaison introuvable");
        return;
      }
      if (addLabel) addLabel.textContent = (window.CELESTIAR_I18N && window.CELESTIAR_I18N.add_to_cart_tpl
        ? window.CELESTIAR_I18N.add_to_cart_tpl
        : (lang === "en" ? "Add to cart — __PRICE__" : "Ajouter au panier — __PRICE__")
      ).replace("__PRICE__", money(state.priceCents));
    }

    /* --- Boutons taille / cadre --- */
    document.querySelectorAll("[data-size]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll("[data-size]").forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        state.size = btn.dataset.size;
        syncVariant();
        if (state.skyReady) paintPoster();
      });
    });
    document.querySelectorAll("[data-frame]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        document.querySelectorAll("[data-frame]").forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        state.frame = btn.dataset.frame;
        if (frameWrap && state.support === "cadre") frameWrap.setAttribute("data-sky-final-frame", state.frame);
        syncVariant();
      });
    });

    var PAL = {
      etoile: { light: ["#6F7587", "#262A36"], dark: ["#EEF1F8", "#FFFFFF"], line: "rgba(255,255,255,0.62)" },
      or: { light: ["#A8873F", "#8A6D2F"], dark: ["#E8D5A3", "#F3E6C4"], line: "rgba(200,196,176,0.42)" },
      argent: { light: ["#8C9099", "#5F636C"], dark: ["#D9DCE3", "#F1F2F5"], line: "rgba(205,210,220,0.42)" },
      rose: { light: ["#B57E82", "#94626A"], dark: ["#E9C2C3", "#F6DCDC"], line: "rgba(228,196,200,0.42)" },
      nuit: { light: ["#2B3A6B", "#1F2A55"], dark: ["#AFC0E8", "#DCE4F7"], line: "rgba(172,192,236,0.45)" },
      cuivre: { light: ["#A8603A", "#7A4325"], dark: ["#EBB08A", "#FBE3D1"] },
      emeraude: { light: ["#2F8A66", "#1F6048"], dark: ["#8EE6BE", "#E1FFF1"] },
      amethyste: { light: ["#6B49B8", "#4B3185"], dark: ["#CDB1FF", "#F3EAFF"] },
      glacier: { light: ["#3A86B0", "#276085"], dark: ["#B6E6FF", "#EEFAFF"] },
      rubis: { light: ["#B02848", "#7E1B33"], dark: ["#FF9FB0", "#FFE4E9"] }
    };
    var SIZE_CM = { "13 × 18 cm": [13, 18], "20 × 25 cm": [20, 25], "21 × 30 cm": [21, 30], "30 × 40 cm": [30, 40], "40 × 50 cm": [40, 50], "50 × 70 cm": [50, 70], "60 × 90 cm": [60, 90], "70 × 100 cm": [70, 100] };
    /* ---------- Affiche : formes, filets dorés, typographie ---------- */
    function hexRgb(h) { h = h.replace("#", ""); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
    function mixHex(h, to, t) {
      var a = hexRgb(h), b = hexRgb(to);
      return "rgb(" + a.map(function (v, i) { return Math.round(v + (b[i] - v) * t); }).join(",") + ")";
    }
    function spaced(c, text, x, y, sp) {
      var ws = [], tot = 0, i, al = c.textAlign;
      for (i = 0; i < text.length; i++) { var w = c.measureText(text[i]).width; ws.push(w); tot += w + sp; }
      var px = x - (tot - sp) / 2;
      c.textAlign = "left";
      for (i = 0; i < text.length; i++) { c.fillText(text[i], px, y); px += ws[i] + sp; }
      c.textAlign = al;
    }
    var GEOM = {
      cercle: { u: 1, d: 1, w: 1 }, signe: { u: 1, d: 1, w: 1 },
      coeur: { u: 1, d: 0.98, w: 1.08 }, etoile: { u: 1.15, d: 1.02, w: 1.14 }, goutte: { u: 0.84, d: 0.98, w: 0.8 },
      ovale: { u: 1, d: 1, w: 0.78 }, planete: { u: 0.85, d: 0.85, w: 1.22, lim: 0.41 }, croissant: { u: 1, d: 1, w: 1 }, initiale: { u: 1, d: 1, w: 1 },
      arche: { u: 1, d: 1, w: 0.8 }, hexagone: { u: 1, d: 1, w: 0.866 }, sapin: { u: 1.15, d: 1.05, w: 0.95 }
    };
    function shapePath(c, shape, x, y, R) {
      c.beginPath();
      if (shape === "coeur") {
        /* Courbe du coeur (x = 16 sin^3 t, y = 13 cos t - 5 cos 2t - 2 cos 3t - cos 4t) : lobes ronds, creux net, pointe fine. */
        var hs = R * 1.08 / 16, hp = 140;
        for (var hi = 0; hi <= hp; hi++) {
          var ht = (hi / hp) * Math.PI * 2;
          var hx = 16 * Math.pow(Math.sin(ht), 3);
          var hy = 13 * Math.cos(ht) - 5 * Math.cos(2 * ht) - 2 * Math.cos(3 * ht) - Math.cos(4 * ht);
          var px = x + hs * hx, py = y - hs * (hy + 2.55);
          if (hi === 0) c.moveTo(px, py); else c.lineTo(px, py);
        }
        c.closePath();
      } else if (shape === "etoile") {
        /* etoile a 5 branches aux sommets arrondis */
        var sp = [];
        for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? R * 0.58 : R * 1.2; sp.push([x + rr * Math.cos(a), y + rr * Math.sin(a) + R * 0.05]); }
        var sm = function (p, q) { return [(p[0] + q[0]) / 2, (p[1] + q[1]) / 2]; };
        var s0 = sm(sp[9], sp[0]);
        c.moveTo(s0[0], s0[1]);
        for (var si = 0; si < 10; si++) {
          var nx = sm(sp[si], sp[(si + 1) % 10]);
          c.arcTo(sp[si][0], sp[si][1], nx[0], nx[1], si % 2 ? R * 0.05 : R * 0.1);
        }
        c.closePath();
      } else if (shape === "goutte") {
        var gp = 120;
        for (var gi = 0; gi <= gp; gi++) {
          var gt = (gi / gp) * Math.PI * 2;
          var gx = Math.sin(gt) * Math.pow(Math.sin(gt / 2), 1.35) * 1.02;
          var gy = -Math.cos(gt);
          var gX = x + R * 0.98 * gx, gY = y + R * 0.9 * gy + R * 0.08;
          if (gi === 0) c.moveTo(gX, gY); else c.lineTo(gX, gY);
        }
        c.closePath();
      } else if (shape === "arche") {
        var aw = R * 0.8, ay = y - R * 0.2;
        c.moveTo(x - aw, y + R); c.lineTo(x - aw, ay); c.arc(x, ay, aw, Math.PI, 0, false); c.lineTo(x + aw, y + R); c.closePath();
      } else if (shape === "hexagone") {
        for (var hxi = 0; hxi < 6; hxi++) { var hxa = -Math.PI / 2 + hxi * Math.PI / 3; if (hxi === 0) c.moveTo(x + R * Math.cos(hxa), y + R * Math.sin(hxa)); else c.lineTo(x + R * Math.cos(hxa), y + R * Math.sin(hxa)); }
        c.closePath();
      } else if (shape === "sapin") {
        var tp = [[0, -1.15], [0.5, -0.45], [0.28, -0.45], [0.72, 0.2], [0.4, 0.2], [0.95, 0.8], [0.14, 0.8], [0.14, 1.05], [-0.14, 1.05], [-0.14, 0.8], [-0.95, 0.8], [-0.4, 0.2], [-0.72, 0.2], [-0.28, -0.45], [-0.5, -0.45]];
        tp.forEach(function (p, ti) { if (ti === 0) c.moveTo(x + p[0] * R, y + p[1] * R); else c.lineTo(x + p[0] * R, y + p[1] * R); });
        c.closePath();
      } else if (shape === "ovale") {
        c.ellipse(x, y, R * 0.78, R, 0, 0, Math.PI * 2);
      } else if (shape === "planete") {
        c.arc(x, y, R * 0.8, 0, Math.PI * 2);
      } else {
        c.arc(x, y, R, 0, Math.PI * 2);
      }
    }
    /* Affiche complete : apercu, image HD Gelato et telechargement (meme rendu partout). */
    /* ======================================================================
       GAMME CELESTIAR : papiers, finitions, typographies, formats de date,
       bordures decoratives. Tout est dessine ici, sans image externe.
       ====================================================================== */

    /* ---- Papiers (arriere-plans) ---- */
    var BGS = {
      blanc:    { dark: false, name: "Blanc nacré" },
      sable:    { dark: false, name: "Sable", base: ["#FAF3E4", "#EEE3CC", "#DDCFB1"] },
      noir:     { dark: true,  name: "Noir laqué", base: ["#15151a", "#08080b", "#020203", "#000000"] },
      nuit:     { dark: true,  name: "Bleu nuit", base: ["#14234d", "#0a1432", "#040916", "#01030a"] },
      foret:    { dark: true,  name: "Vert forêt", base: ["#13392d", "#0a2019", "#04100c", "#010503"] },
      bordeaux: { dark: true,  name: "Bordeaux", base: ["#431523", "#26090f", "#10040a", "#050102"] },
      ardoise:  { dark: true,  name: "Ardoise", base: ["#2e323d", "#1a1d25", "#0b0c10", "#030304"] },
      rose:     { dark: false, name: "Rose poudré", base: ["#FDF2F2", "#F3DDDF", "#E6C7CB"] },
      azur:     { dark: false, name: "Azur", base: ["#F5F9FD", "#DEEBF5", "#C6D9EA"] },
      prune:    { dark: true,  name: "Prune", base: ["#3d1e49", "#240f2e", "#10061a", "#050208"] }
    };

    /* Arriere-plan haut de gamme : degrade profond, spot de lumiere venu du haut, eclat diagonal, vignette,
       arete lumineuse (papiers sombres) ; blanc nacre / sable (papiers clairs). */
    function paintBackdrop(c, W, H, key) {
      var B = BGS[key] || BGS.noir, dark = B.dark, g;
      g = c.createLinearGradient(0, 0, W * 0.9, H);
      if (dark) { g.addColorStop(0, B.base[0]); g.addColorStop(0.28, B.base[1]); g.addColorStop(0.65, B.base[2]); g.addColorStop(1, B.base[3]); }
      else if (B.base) { g.addColorStop(0, B.base[0]); g.addColorStop(0.5, B.base[1]); g.addColorStop(1, B.base[2]); }
      else { g.addColorStop(0, "#FFFFFF"); g.addColorStop(0.5, "#F7F3EA"); g.addColorStop(1, "#E7E1D3"); }
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      g = c.createRadialGradient(W * 0.5, -H * 0.08, 0, W * 0.5, -H * 0.08, H * 0.95);
      if (dark) { g.addColorStop(0, "rgba(255,255,255,0.075)"); g.addColorStop(0.45, "rgba(255,255,255,0.025)"); g.addColorStop(1, "rgba(255,255,255,0)"); }
      else { g.addColorStop(0, "rgba(255,255,255,0.95)"); g.addColorStop(0.5, "rgba(255,255,255,0.35)"); g.addColorStop(1, "rgba(255,255,255,0)"); }
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      g = c.createLinearGradient(0, 0, W * 0.85, H * 0.6);
      if (dark) { g.addColorStop(0, "rgba(255,255,255,0.12)"); g.addColorStop(0.22, "rgba(255,255,255,0.045)"); g.addColorStop(0.5, "rgba(255,255,255,0)"); }
      else { g.addColorStop(0, "rgba(255,255,255,0.9)"); g.addColorStop(0.25, "rgba(255,255,255,0.35)"); g.addColorStop(0.5, "rgba(255,255,255,0)"); }
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      g = c.createLinearGradient(W, H, W * 0.4, H * 0.5);
      if (dark) { g.addColorStop(0, "rgba(255,255,255,0.025)"); g.addColorStop(1, "rgba(255,255,255,0)"); }
      else { g.addColorStop(0, "rgba(120,102,70,0.08)"); g.addColorStop(1, "rgba(120,102,70,0)"); }
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      g = c.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.42, W / 2, H / 2, Math.max(W, H) * 0.8);
      g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, dark ? "rgba(0,0,0,0.55)" : "rgba(110,92,60,0.13)");
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      if (dark) {
        g = c.createLinearGradient(0, 0, W, 0); g.addColorStop(0, "rgba(255,255,255,0.22)"); g.addColorStop(0.5, "rgba(255,255,255,0.08)"); g.addColorStop(1, "rgba(255,255,255,0)");
        c.fillStyle = g; c.fillRect(0, 0, W, Math.max(1.5, W / 520));
        g = c.createLinearGradient(0, 0, 0, H); g.addColorStop(0, "rgba(255,255,255,0.2)"); g.addColorStop(0.45, "rgba(255,255,255,0.05)"); g.addColorStop(1, "rgba(255,255,255,0)");
        c.fillStyle = g; c.fillRect(0, 0, Math.max(1.5, W / 520), H);
      }
    }

    /* Reflets de vitre (profil releve sur l'affiche noire de reference) */
    function glassReflections(W, H, peak) {
      var cv = document.createElement("canvas"); cv.width = W; cv.height = H; var c = cv.getContext("2d");
      var pts = [[0, 0], [0.03, 0], [0.095, 0.7], [0.143, 0.85], [0.19, 1], [0.238, 0.75], [0.27, 0], [0.30, 0], [0.325, 0.9], [0.38, 0.95], [0.45, 0.95], [0.5, 0.62], [0.545, 1], [0.62, 1], [0.645, 0.1], [0.665, 0.1], [0.69, 0.5], [0.715, 0.5], [0.745, 0], [1, 0]];
      var gx = c.createLinearGradient(0, 0, W, 0);
      pts.forEach(function (p) { gx.addColorStop(p[0], "rgba(255,255,255," + (p[1] * peak).toFixed(4) + ")"); });
      c.fillStyle = gx; c.fillRect(0, 0, W, H);
      var vs = [[0, 0.5], [0.04, 0.85], [0.105, 0.85], [0.125, 0.04], [0.20, 0.04], [0.225, 0.95], [0.30, 1], [0.88, 1], [1, 0.62]];
      c.globalCompositeOperation = "destination-in";
      var gy = c.createLinearGradient(0, 0, 0, H);
      vs.forEach(function (p) { gy.addColorStop(p[0], "rgba(0,0,0," + p[1] + ")"); });
      c.fillStyle = gy; c.fillRect(0, 0, W, H);
      return cv;
    }

    /* Calque de reflets (intensites « papier sombre »), reutilise tel quel ou retouche pour les papiers clairs */
    function finishLayer(W, H, kind) {
      var cv = document.createElement("canvas"); cv.width = W; cv.height = H; var c = cv.getContext("2d"), D = Math.PI / 180;
      function glow(x, y, r, rgb, a) { var g = c.createRadialGradient(x, y, 0, x, y, r); g.addColorStop(0, "rgba(" + rgb + "," + a + ")"); g.addColorStop(1, "rgba(" + rgb + ",0)"); c.fillStyle = g; c.fillRect(0, 0, W, H); }
      if (kind === "vitre") {
        c.drawImage(glassReflections(W, H, 0.155), 0, 0);
      } else if (kind === "eclat") {
        c.translate(W * 0.5, H * 0.5); c.rotate(-24 * D); var L = Math.max(W, H) * 1.8;
        [[-0.34, 0.22, 0.13], [-0.06, 0.075, 0.11], [0.08, 0.03, 0.10], [0.30, 0.12, 0.07]].forEach(function (bm) {
          var cx = bm[0] * W, w = bm[1] * W, g = c.createLinearGradient(cx - w / 2, 0, cx + w / 2, 0);
          g.addColorStop(0, "rgba(255,255,255,0)"); g.addColorStop(0.5, "rgba(255,255,255," + bm[2] + ")"); g.addColorStop(1, "rgba(255,255,255,0)");
          c.fillStyle = g; c.fillRect(cx - w / 2, -L / 2, w, L);
        });
      } else if (kind === "aurore") {
        glow(W * 0.04, H * 0.02, W * 0.95, "255,206,120", 0.20); glow(W, H, W * 1.0, "140,120,255", 0.17);
        glow(W * 0.95, H * 0.1, W * 0.55, "110,200,255", 0.09); glow(W * 0.08, H * 0.96, W * 0.5, "255,150,190", 0.08);
      } else if (kind === "voile") {
        var ox = W * 0.5, oy = -H * 0.06, len = H * 1.5;
        for (var i = 0; i < 11; i++) {
          var ang = (-38 + i * 7.6) * D, hw = (i % 2 ? 1.5 : 3.6) * D, a = i % 2 ? 0.05 : 0.09;
          var ex = ox + Math.sin(ang) * len, ey = oy + Math.cos(ang) * len, gr = c.createLinearGradient(ox, oy, ex, ey);
          gr.addColorStop(0, "rgba(255,255,255," + a + ")"); gr.addColorStop(1, "rgba(255,255,255,0)");
          c.fillStyle = gr; c.beginPath(); c.moveTo(ox, oy);
          c.lineTo(ox + Math.sin(ang - hw) * len, oy + Math.cos(ang - hw) * len); c.lineTo(ox + Math.sin(ang + hw) * len, oy + Math.cos(ang + hw) * len); c.closePath(); c.fill();
        }
      } else if (kind === "soie") {
        c.lineWidth = Math.max(1, W / 700);
        for (var s = 0; s < 80; s++) {
          var t = s / 79, y0 = H * (-0.05 + 1.1 * t), amp = H * (0.05 + 0.08 * Math.sin(t * 3.1));
          var gl = c.createLinearGradient(0, 0, W, 0), al = 0.075 * (0.4 + 0.6 * Math.abs(Math.sin(t * 17)));
          gl.addColorStop(0, "rgba(255,255,255,0)"); gl.addColorStop(0.35, "rgba(255,255,255," + al.toFixed(3) + ")"); gl.addColorStop(0.7, "rgba(255,255,255," + (al * 0.4).toFixed(3) + ")"); gl.addColorStop(1, "rgba(255,255,255,0)");
          c.strokeStyle = gl; c.beginPath(); c.moveTo(-W * 0.1, y0 + amp * 0.3);
          c.bezierCurveTo(W * 0.25, y0 - amp, W * 0.6, y0 + amp * 1.1, W * 1.1, y0 - amp * 0.4); c.stroke();
        }
      }
      return cv;
    }
    /* Papier sombre : reflets par-dessus tout le dessin (effet vitre).
       Papier clair : on assombrit tres legerement le papier PARTOUT SAUF dans les zones de reflet, puis on y ajoute la lumiere :
       le brillant devient visible meme sur du blanc. */
    function drawFinish(c, W, H, dark, kind) {
      var layer = finishLayer(W, H, kind);
      if (dark) { c.save(); c.globalCompositeOperation = "screen"; c.drawImage(layer, 0, 0); c.restore(); return; }
      var t = document.createElement("canvas"); t.width = W; t.height = H; var tx = t.getContext("2d");
      tx.fillStyle = "rgba(86,70,42,0.14)"; tx.fillRect(0, 0, W, H);
      tx.globalCompositeOperation = "destination-out";
      for (var k = 0; k < 5; k++) tx.drawImage(layer, 0, 0);
      c.drawImage(t, 0, 0);
      c.save(); for (k = 0; k < 3; k++) c.drawImage(layer, 0, 0); c.restore();
    }

    /* ---- Typographies : le titre (prenom) et le texte courant ---- */
    var FONTS = {
      elegance:   { name: "Élégance",   title: '"Cormorant Garamond", serif', tw: "600", body: '"Cormorant Garamond", serif', caps: true },
      gravure:    { name: "Gravure",    title: '"SK Cinzel", "Cormorant Garamond", serif', tw: "400", body: '"Cormorant Garamond", serif', caps: true, sizeScale: 0.9, faces: ["SK Cinzel"] },
      editorial:  { name: "Éditorial",  title: '"SK Playfair", "Cormorant Garamond", serif', tw: "400", body: '"Cormorant Garamond", serif', caps: false, sizeScale: 0.88, faces: ["SK Playfair"] },
      manuscrit:  { name: "Manuscrit",  title: '"SK Great Vibes", cursive', tw: "400", body: '"Cormorant Garamond", serif', caps: false, sizeScale: 1.3, faces: ["SK Great Vibes"] },
      romantique: { name: "Romantique", title: '"SK Pinyon", cursive', tw: "400", body: '"Cormorant Garamond", serif', caps: false, sizeScale: 1.18, faces: ["SK Pinyon"] },
      deco:       { name: "Art déco",   title: '"SK Poiret", sans-serif', tw: "400", body: '"SK Josefin", sans-serif', caps: true, noItalic: true, sizeScale: 1.05, faces: ["SK Poiret", "SK Josefin"] },
      moderne:    { name: "Moderne",    title: '"SK Montserrat", sans-serif', tw: "500", body: '"SK Josefin", sans-serif', caps: true, noItalic: true, sizeScale: 0.72, faces: ["SK Montserrat", "SK Josefin"] },
      cinema:     { name: "Cinéma",     title: '"SK Limelight", serif', tw: "400", body: '"SK Marcellus", serif', caps: true, noItalic: true, sizeScale: 0.85, faces: ["SK Limelight", "SK Marcellus"] }
    };
    function ensureFonts(cb) {
      var F = FONTS[style.font] || FONTS.elegance;
      if (!F.faces || !document.fonts || !document.fonts.load) { if (cb) cb(); return; }
      Promise.all(F.faces.map(function (f) { return document.fonts.load('400 40px "' + f + '"'); })).then(function () { if (cb) cb(); }, function () { if (cb) cb(); });
    }

    /* ---- Formats de date : texte, chiffres, chiffres romains, en toutes lettres ---- */
    function romanize(n) {
      var m = [[1000, "M"], [900, "CM"], [500, "D"], [400, "CD"], [100, "C"], [90, "XC"], [50, "L"], [40, "XL"], [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"]], s = "";
      m.forEach(function (p) { while (n >= p[0]) { s += p[1]; n -= p[0]; } });
      return s;
    }
    var FR_U = ["zéro", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"];
    function fr99(n) {
      if (n < 20) return FR_U[n];
      var t = Math.floor(n / 10), u = n % 10, T = { 2: "vingt", 3: "trente", 4: "quarante", 5: "cinquante", 6: "soixante" };
      if (t <= 6) return T[t] + (u === 0 ? "" : (u === 1 ? " et un" : "-" + FR_U[u]));
      if (t === 7) { var r = n - 60; return "soixante" + (r === 11 ? " et onze" : "-" + FR_U[r]); }
      if (t === 8) return u === 0 ? "quatre-vingts" : "quatre-vingt-" + FR_U[u];
      return "quatre-vingt-" + FR_U[10 + u];
    }
    function frNum(n) {
      if (n < 100) return fr99(n);
      var th = Math.floor(n / 1000), h = Math.floor(n / 100) % 10, rest = n % 100, s = "";
      if (th > 0) s += th === 1 ? "mille" : FR_U[th] + " mille";
      if (h > 0) s += (s ? " " : "") + (h === 1 ? "cent" : FR_U[h] + " cent" + (rest === 0 ? "s" : ""));
      if (rest > 0) s += (s ? " " : "") + fr99(rest);
      return s;
    }
    function fmtDateStyle(v, fmt) {
      if (!v) return "";
      var d = new Date(v + "T00:00:00"); if (isNaN(d)) return "";
      var dd = d.getDate(), mm = d.getMonth() + 1, yy = d.getFullYear();
      if (fmt === "chiffres") return ("0" + dd).slice(-2) + "." + ("0" + mm).slice(-2) + "." + yy;
      if (fmt === "romain") return romanize(dd) + " · " + romanize(mm) + " · " + romanize(yy);
      if (fmt === "lettres" && lang !== "en" && yy >= 1900 && yy <= 2999) {
        var month = d.toLocaleDateString("fr-FR", { month: "long" });
        return (dd === 1 ? "premier" : frNum(dd)) + " " + month + " " + frNum(yy);
      }
      return fmtDate(v);
    }
    function dms(v, pos, neg) { var a = Math.abs(v), dg = Math.floor(a), mn = Math.round((a - dg) * 60); if (mn === 60) { dg += 1; mn = 0; } return dg + "°" + ("0" + mn).slice(-2) + "′" + (v >= 0 ? pos : neg); }
    function fmtCoords(lat, lng) { return dms(lat, "N", "S") + "   ·   " + dms(lng, "E", lang === "en" ? "W" : "O"); }

    /* ---- Bordures decoratives autour du ciel (cercle) : signature Celestiar ---- */
    function moonPhase(c, x, y, r, p, fill) {
      c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.stroke();
      if (p > 0.02 && p < 0.98) {
        var waxing = p < 0.5, q = waxing ? p : 1 - p, rx = r * Math.cos(2 * Math.PI * q);
        c.save(); c.translate(x, y); if (!waxing) c.scale(-1, 1);
        c.beginPath(); c.arc(0, 0, r * 0.84, -Math.PI / 2, Math.PI / 2, false);
        c.ellipse(0, 0, Math.max(0.01, Math.abs(rx) * 0.84), r * 0.84, 0, Math.PI / 2, -Math.PI / 2, rx > 0);
        c.closePath(); c.fillStyle = fill; c.fill(); c.restore();
      }
    }
    function star4(c, x, y, s) {
      var k = s * 0.17; c.beginPath(); c.moveTo(x, y - s); c.quadraticCurveTo(x + k, y - k, x + s, y); c.quadraticCurveTo(x + k, y + k, x, y + s);
      c.quadraticCurveTo(x - k, y + k, x - s, y); c.quadraticCurveTo(x - k, y - k, x, y - s); c.closePath(); c.fill();
    }
    function drawOrnament(c, kind, cx, cy, R, fill, W, info) {
      var g1 = info.g1, g2 = info.g2, lwOut = info.lwOut, i, a, r0, r1;
      c.save(); c.strokeStyle = fill; c.fillStyle = fill; c.lineCap = "round";
      if (kind === "graduations") {
        var tr0 = R + g1 + (g2 - g1) * 0.32, tr1 = R + g1 + (g2 - g1) * 0.78;
        for (i = 0; i < 72; i++) {
          a = i * Math.PI / 36; var major = i % 18 === 0, mid = i % 6 === 0;
          var t0 = major ? R + g1 + W * 0.002 : tr0, t1 = major ? R + g2 - W * 0.002 : (mid ? tr1 : (tr0 + tr1) / 2);
          c.lineWidth = major ? lwOut * 1.8 : lwOut; c.globalAlpha = major ? 0.95 : 0.55;
          c.beginPath(); c.moveTo(cx + t0 * Math.sin(a), cy - t0 * Math.cos(a)); c.lineTo(cx + t1 * Math.sin(a), cy - t1 * Math.cos(a)); c.stroke();
        }
      } else if (kind === "rayons") {
        r0 = R + g2 + W * 0.008;
        for (i = 0; i < 144; i++) {
          a = i * Math.PI / 72; var lg = i % 6 === 0, md = i % 2 === 0;
          r1 = r0 + (lg ? W * 0.026 : md ? W * 0.016 : W * 0.009); c.lineWidth = lg ? lwOut * 1.7 : lwOut * 0.9; c.globalAlpha = lg ? 0.95 : 0.7;
          c.beginPath(); c.moveTo(cx + r0 * Math.sin(a), cy - r0 * Math.cos(a)); c.lineTo(cx + r1 * Math.sin(a), cy - r1 * Math.cos(a)); c.stroke();
        }
      } else if (kind === "lune") {
        var ph = [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875], rr = R + g2 + W * 0.03, mr = W * 0.0165;
        c.lineWidth = Math.max(1, lwOut); c.globalAlpha = 0.95;
        for (i = 0; i < 8; i++) { a = (i * 45 - 90) * Math.PI / 180; moonPhase(c, cx + rr * Math.cos(a), cy + rr * Math.sin(a), mr, ph[i], fill); }
      } else if (kind === "mois") {
        var rr2 = R + g2 + W * 0.032, letters = "JFMAMJJASOND";
        c.textAlign = "center"; c.textBaseline = "middle";
        for (i = 0; i < 12; i++) {
          a = (i * 30 - 75) * Math.PI / 180; var x = cx + rr2 * Math.cos(a), y = cy + rr2 * Math.sin(a), on = i === info.monthIdx;
          c.globalAlpha = on ? 1 : 0.6; c.font = (on ? "700 " : "500 ") + W * (on ? 0.027 : 0.022) + "px " + info.bodyFam; c.fillText(letters[i], x, y);
          if (on) { c.lineWidth = lwOut * 1.2; c.beginPath(); c.arc(x, y, W * 0.022, 0, Math.PI * 2); c.stroke(); }
        }
      } else if (kind === "boussole") {
        var rr3 = R + g2 + W * 0.034; c.globalAlpha = 0.95;
        for (i = 0; i < 4; i++) { a = i * Math.PI / 2 - Math.PI / 2; star4(c, cx + rr3 * Math.cos(a), cy + rr3 * Math.sin(a), W * 0.03); }
        for (i = 0; i < 4; i++) { a = i * Math.PI / 2 - Math.PI / 4; star4(c, cx + (rr3 - W * 0.004) * Math.cos(a), cy + (rr3 - W * 0.004) * Math.sin(a), W * 0.0125); }
      } else if (kind === "guirlande") {
        var rg = R + g2 + W * 0.034; c.globalAlpha = 0.95;
        for (i = 0; i < 48; i++) {
          a = i * Math.PI / 24; var gx = cx + rg * Math.cos(a), gy = cy + rg * Math.sin(a);
          if (i % 12 === 0) star4(c, gx, gy, W * 0.028); else if (i % 3 === 0) star4(c, gx, gy, W * 0.0115); else { c.beginPath(); c.arc(gx, gy, W * 0.0032, 0, Math.PI * 2); c.fill(); }
        }
      } else if (kind === "coeurs") {
        var rh = R + g2 + W * 0.034; c.globalAlpha = 0.95;
        for (i = 0; i < 28; i++) {
          a = i * Math.PI * 2 / 28 - Math.PI / 2; var hs2 = (i % 7 === 0) ? W * 0.0125 : W * 0.0078;
          c.save(); c.translate(cx + rh * Math.cos(a), cy + rh * Math.sin(a)); c.rotate(a + Math.PI / 2 - Math.PI / 2 + Math.PI / 2);
          c.beginPath(); c.moveTo(0, hs2 * 0.95); c.bezierCurveTo(-hs2 * 1.7, -hs2 * 0.2, -hs2 * 0.85, -hs2 * 1.5, 0, -hs2 * 0.55); c.bezierCurveTo(hs2 * 0.85, -hs2 * 1.5, hs2 * 1.7, -hs2 * 0.2, 0, hs2 * 0.95); c.closePath(); c.fill(); c.restore();
        }
      } else if (kind === "couronne") {
        var rc = R + g2 + W * 0.03, side, k, th, lx, ly, rot, off;
        c.globalAlpha = 0.9; c.lineWidth = Math.max(1, lwOut);
        for (side = -1; side <= 1; side += 2) {
          c.beginPath(); for (k = 0; k <= 30; k++) { th = (90 - side * (6 + k * 1.7)) * Math.PI / 180; var sx = cx + rc * Math.cos(th), sy = cy + rc * Math.sin(th); if (k === 0) c.moveTo(sx, sy); else c.lineTo(sx, sy); } c.stroke();
          for (k = 0; k < 16; k++) {
            th = (90 - side * (8 + k * 3.2)) * Math.PI / 180; rot = th - side * Math.PI / 2;
            [-1, 1].forEach(function (io) {
              off = io * W * 0.0075; lx = cx + (rc + off) * Math.cos(th); ly = cy + (rc + off) * Math.sin(th);
              c.beginPath(); c.ellipse(lx, ly, W * (0.016 - k * 0.00025), W * 0.0052, rot + io * side * 0.55, 0, Math.PI * 2); c.fill();
            });
          }
        }
      }
      c.restore();
    }


    function paintPosterTo(pc, sky, preview) {
      var W = pc.width, H = pc.height, ctx = pc.getContext("2d");
      var BG = BGS[style.bg] || BGS.noir, dark = BG.dark, pal = PAL[style.palette] || PAL.etoile, LK = getLook(style.palette, style.sky);
      var ACC = dark ? pal.dark[0] : pal.light[0], TXT = dark ? pal.dark[1] : pal.light[1];
      var F = FONTS[style.font] || FONTS.elegance, fsc = F.sizeScale || 1;
      var prenomRaw = (prenomI && prenomI.value.trim()) || "";
      var prenom = F.caps ? prenomRaw.toUpperCase() : prenomRaw;
      var phrase = phraseI ? phraseI.value.trim() : "";
      if (phrase) phrase = phrase.charAt(0).toUpperCase() + phrase.slice(1);
      var lieu = (locI && locI.value.trim().split(",")[0]) || "";
      var dateTxt = fmtDateStyle(dateI && dateI.value, style.datefmt), heureTxt = (timeI && timeI.value) || "";
      var shape = style.shape; if (!GEOM[shape]) shape = "cercle";
      var g = GEOM[shape];
      var signInfo = shape === "signe" ? zodiacFor(dateI && dateI.value, lang) : null;
      var circleLike = shape === "cercle" || shape === "signe";
      var orn = circleLike ? (style.border || "fin") : "fin";
      var coordTxt = (coordI && coordI.checked && state.coords) ? fmtCoords(state.coords.lat, state.coords.lng) : "";
      var lay = style.layout || "classique";
      var customHead = headI ? headI.value.trim() : "";
      var monthIdx = (dateI && /^\d{4}-\d{2}/.test(dateI.value || "")) ? parseInt(dateI.value.slice(5, 7), 10) - 1 : -1;

      /* arriere-plan : papier choisi + finition de reflets (papier clair : sous le dessin) */
      paintBackdrop(ctx, W, H, style.bg);
      var finish = style.finish || "laque";
      if (!dark && finish !== "laque") drawFinish(ctx, W, H, false, finish);

      /* filets du cadre : double filet dore */
      var m = W * 0.045;
      var foilBox = ctx.createLinearGradient(0, 0, W, H);
      foilBox.addColorStop(0, mixHex(ACC, "#ffffff", 0.3)); foilBox.addColorStop(0.5, ACC); foilBox.addColorStop(1, mixHex(ACC, "#000000", 0.18));
      ctx.strokeStyle = foilBox; ctx.globalAlpha = 0.7; ctx.lineWidth = Math.max(1, W * 0.0022);
      ctx.strokeRect(m, m, W - 2 * m, H - 2 * m);
      ctx.globalAlpha = 0.4; ctx.lineWidth = Math.max(1, W * 0.0012);
      ctx.strokeRect(m + W * 0.012, m + W * 0.012, W - 2 * m - W * 0.024, H - 2 * m - W * 0.024);
      ctx.globalAlpha = 1;

      /* titre en haut : titre personnalise, sinon la marque */
      var showBrand = customHead ? true : (!brandI || brandI.checked);
      ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillStyle = ACC;
      if (showBrand) {
        if (customHead) { ctx.font = "500 " + W * 0.028 + "px " + F.body; spaced(ctx, customHead.toUpperCase(), W / 2, m + W * 0.062, W * 0.012); }
        else { ctx.font = "500 " + W * 0.03 + 'px "Cormorant Garamond", serif'; spaced(ctx, "CELESTIAR", W / 2, m + W * 0.062, W * 0.014); }
      }

      /* ---- briques de texte (typographie choisie) ---- */
      function setTitle(sz) { ctx.font = F.tw + " " + sz + "px " + F.title; }
      function setBody(sz, italic, wt) { ctx.font = (italic && !F.noItalic ? "italic " : "") + (wt || "500") + " " + sz + "px " + F.body; }
      function nameText() { return prenom || (F.caps ? (lang === "en" ? "YOUR NAME" : "VOTRE PRÉNOM") : (lang === "en" ? "Your name" : "Votre prénom")); }
      function drawName(y, base) {
        var txt = nameText(), sz = base; setTitle(sz);
        while (ctx.measureText(txt).width > W * 0.78 && sz > W * 0.03) { sz *= 0.94; setTitle(sz); }
        ctx.fillStyle = TXT; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText(txt, W / 2, y);
      }
      function drawRule(y) {
        ctx.strokeStyle = ACC; ctx.fillStyle = ACC; ctx.lineWidth = Math.max(1, W * 0.0014); ctx.globalAlpha = 0.85;
        var ow = W * 0.085, od = W * 0.007;
        ctx.beginPath(); ctx.moveTo(W / 2 - ow - od * 3, y); ctx.lineTo(W / 2 - od * 3, y); ctx.moveTo(W / 2 + od * 3, y); ctx.lineTo(W / 2 + ow + od * 3, y); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(W / 2, y - od); ctx.lineTo(W / 2 + od, y); ctx.lineTo(W / 2, y + od); ctx.lineTo(W / 2 - od, y); ctx.closePath(); ctx.fill();
        ctx.globalAlpha = 1;
      }
      function dateLine() { var d = dateTxt ? (F.caps || style.datefmt === "romain" ? dateTxt.toUpperCase() : dateTxt) : ""; return d + (heureTxt ? "  ·  " + heureTxt : ""); }
      function fitSpaced(txt, y, size, sp, wt, italic) {
        var sz = size; setBody(sz, italic, wt);
        var meas = function () { var w = 0; for (var i = 0; i < txt.length; i++) w += ctx.measureText(txt[i]).width + sp; return w - sp; };
        while (meas() > W * 0.82 && sz > W * 0.014) { sz *= 0.94; sp *= 0.94; setBody(sz, italic, wt); }
        spaced(ctx, txt, W / 2, y, sp);
      }
      function drawDate(y, size) { var dl = dateLine(); if (!dl) return; ctx.fillStyle = TXT; ctx.textAlign = "center"; fitSpaced(dl, y, size, W * 0.006, "500", false); }
      function drawPlace(y, size) { if (!lieu) return; ctx.fillStyle = ACC; ctx.textAlign = "center"; setBody(size, true, "500"); ctx.fillText(lieu, W / 2, y); }
      function drawCoords(y, size) { if (!coordTxt) return; ctx.fillStyle = ACC; ctx.globalAlpha = 0.85; ctx.textAlign = "center"; fitSpaced(coordTxt, y, size, W * 0.004, "500", false); ctx.globalAlpha = 1; }
      function drawPhrase(y, size) {
        if (!phrase) return; var sz = size, txt = "« " + phrase + " »"; ctx.fillStyle = TXT; ctx.textAlign = "center"; setBody(sz, true, "500");
        while (ctx.measureText(txt).width > W * 0.8 && sz > W * 0.014) { sz *= 0.95; setBody(sz, true, "500"); }
        ctx.fillText(txt, W / 2, y);
      }

      /* ---- mise en page ---- */
      var nameBase = W * 0.085 * fsc, gap = W * 0.05, headOff = W * (showBrand ? 0.125 : 0.07), topY, textTop, drawText;
      if (lay === "titre") {
        /* le prenom ouvre l'affiche, le ciel au centre, la phrase en pied */
        var yN = m + W * (showBrand ? 0.145 : 0.1), yR = yN + W * 0.062, yD = yR + W * 0.04, yP = yD + W * 0.045, yC = yP + (coordTxt ? W * 0.04 : 0);
        topY = (coordTxt ? yC : yP) + W * 0.075; textTop = H - m - W * (phrase ? 0.125 : 0.045);
        drawText = function () { drawName(yN, nameBase); drawRule(yR); drawDate(yD, W * 0.028); drawPlace(yP, W * 0.034); if (coordTxt) drawCoords(yC, W * 0.02); drawPhrase(H - m - W * 0.075, W * 0.03); };
      } else if (lay === "minimal") {
        /* grand ciel, signature discrete en pied */
        var blockH = W * 0.052 + W * 0.04 + (coordTxt ? W * 0.035 : 0) + (phrase ? W * 0.05 : 0), y1 = H - m - W * 0.06 - blockH + W * 0.026;
        topY = m + W * (showBrand ? 0.115 : 0.06); textTop = y1 - W * 0.04;
        drawText = function () {
          var y = y1, txt = nameText(), sz = W * 0.05 * fsc; setTitle(sz);
          if (F.caps) { var mw = function () { var w = 0; for (var i = 0; i < txt.length; i++) w += ctx.measureText(txt[i]).width + W * 0.012; return w; }; while (mw() > W * 0.8 && sz > W * 0.02) { sz *= 0.94; setTitle(sz); } ctx.fillStyle = TXT; spaced(ctx, txt, W / 2, y, W * 0.012); }
          else { while (ctx.measureText(txt).width > W * 0.8 && sz > W * 0.02) { sz *= 0.94; setTitle(sz); } ctx.fillStyle = TXT; ctx.fillText(txt, W / 2, y); }
          y += W * 0.045;
          var line = [dateLine(), lieu].filter(Boolean).join("   ·   "); if (line) { ctx.fillStyle = ACC; fitSpaced(F.caps ? line.toUpperCase() : line, y, W * 0.024, W * 0.005, "500", false); }
          y += W * 0.035; if (coordTxt) { drawCoords(y, W * 0.018); y += W * 0.035; }
          drawPhrase(y + W * 0.008, W * 0.027);
        };
      } else {
        var rows = W * 0.062 + W * 0.04 + W * 0.045 + (coordTxt ? W * 0.04 : 0) + (phrase ? W * 0.055 : 0), botY = H - m - W * 0.075, ty0 = botY - rows;
        textTop = ty0 - W * 0.05; topY = m + headOff;
        drawText = function () {
          var ty = ty0; drawName(ty, nameBase); ty += W * 0.062; drawRule(ty); ty += W * 0.04; drawDate(ty, W * 0.028);
          ty += W * 0.045; drawPlace(ty, W * 0.034); if (coordTxt) { ty += W * 0.04; drawCoords(ty, W * 0.02); } if (phrase) { ty += W * 0.055; drawPhrase(ty, W * 0.03); }
        };
      }
      var avail = textTop - gap - topY;
      var ornK = (orn === "lune" || orn === "mois" || orn === "boussole" || orn === "rayons" || orn === "guirlande" || orn === "coeurs" || orn === "couronne") ? 0.86 : 1;
      var R = Math.min(W * (g.lim || 0.335) / g.w, avail / (g.u + g.d)) * ornK;
      var cx = W / 2, cy = topY + (avail - (g.u + g.d) * R) / 2 + g.u * R;

      /* masque de forme : le ciel n'est que recadre, jamais deforme */
      var off = document.createElement("canvas"); off.width = W; off.height = H;
      var oc = off.getContext("2d");
      var mt = null, asc = 0, desc = 0, letter = prenom.charAt(0) || "A";
      if (shape === "initiale") {
        oc.font = "700 " + R * 2.35 + 'px "Cormorant Garamond", Georgia, serif';
        oc.textAlign = "center"; oc.textBaseline = "alphabetic";
        mt = oc.measureText(letter);
        asc = mt.actualBoundingBoxAscent || R * 1.6; desc = mt.actualBoundingBoxDescent || 0;
        oc.fillStyle = "#fff"; oc.fillText(letter, cx, cy + (asc - desc) / 2);
      } else if (shape === "croissant") {
        oc.fillStyle = "#fff"; oc.beginPath(); oc.arc(cx, cy, R, 0, Math.PI * 2); oc.fill();
        oc.globalCompositeOperation = "destination-out";
        oc.beginPath(); oc.arc(cx + R * 0.42, cy - R * 0.16, R * 0.8, 0, Math.PI * 2); oc.fill();
        oc.globalCompositeOperation = "source-over";
      } else { shapePath(oc, shape, cx, cy, R); oc.fillStyle = "#fff"; oc.fill(); }
      var lightSky = style.sky === "blanc";
      var skyBox = (sky && sky.width) ? (function () { var S = sky.width, K = shape === "coeur" || shape === "initiale" ? 1.3 : (shape === "etoile" ? 1.28 : (shape === "arche" ? 1.28 : 1)), sR = S * 0.36; return [S / 2 - sR, S * 0.46 - sR, sR * 2, sR * 2, cx - R * K, cy - R * K, R * 2 * K, R * 2 * K]; })() : null;
      if (lightSky) {
        var mk = document.createElement("canvas"); mk.width = W; mk.height = H; mk.getContext("2d").drawImage(off, 0, 0);
        oc.globalCompositeOperation = "source-over"; oc.clearRect(0, 0, W, H);
        if (skyBox) oc.drawImage(sky, skyBox[0], skyBox[1], skyBox[2], skyBox[3], skyBox[4], skyBox[5], skyBox[6], skyBox[7]);
        oc.globalCompositeOperation = "destination-in"; oc.drawImage(mk, 0, 0);
        oc.globalCompositeOperation = "source-over";
      } else {
        oc.globalCompositeOperation = "source-in";
        oc.fillStyle = LK.disk; oc.fillRect(0, 0, W, H);
        if (skyBox) oc.drawImage(sky, skyBox[0], skyBox[1], skyBox[2], skyBox[3], skyBox[4], skyBox[5], skyBox[6], skyBox[7]);
        oc.save();
        oc.globalCompositeOperation = "source-atop";
        var vg = oc.createRadialGradient(cx, cy, R * 0.25, cx, cy, R * 1.04);
        vg.addColorStop(0, "rgba(0,0,0,0)"); vg.addColorStop(0.9, "rgba(0,0,0,0)"); vg.addColorStop(1, "rgba(0,0,0,0.18)");
        oc.fillStyle = vg; oc.fillRect(0, 0, W, H);
        oc.restore();
      }

      /* filets dores de la forme (degrade « feuille d'or ») */
      var foil = ctx.createLinearGradient(cx - R, cy - R, cx + R, cy + R);
      foil.addColorStop(0, mixHex(ACC, "#ffffff", 0.35)); foil.addColorStop(0.5, ACC); foil.addColorStop(1, mixHex(ACC, "#000000", 0.2));
      var lwIn = Math.max(1.5, W * 0.0042), lwOut = Math.max(1, W * 0.0016), g1 = W * 0.012, g2 = W * 0.026;
      var sc = shape === "etoile" ? 1.05 : 1;

      if (shape === "planete") {
        var ringRx = R * 1.22, ringRy = R * 0.32, rot = -0.32;
        ctx.save(); ctx.translate(cx, cy); ctx.rotate(rot);
        ctx.strokeStyle = foil; ctx.lineWidth = lwIn * 1.2;
        ctx.beginPath(); ctx.ellipse(0, 0, ringRx, ringRy, 0, Math.PI, Math.PI * 2, false); ctx.stroke();
        ctx.restore();
      }
      ctx.drawImage(off, 0, 0);

      ctx.strokeStyle = foil;
      if (shape === "initiale") {
        ctx.font = oc.font; ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
        ctx.lineWidth = lwIn; ctx.strokeText(letter, cx, cy + (asc - desc) / 2);
        ctx.textBaseline = "middle";
      } else if (shape === "croissant") {
        var ix = cx + R * 0.42, iy = cy - R * 0.16, ir = R * 0.8;
        ctx.lineWidth = lwIn;
        ctx.save(); ctx.beginPath(); ctx.rect(0, 0, W, H); ctx.arc(ix, iy, ir, 0, Math.PI * 2, true); ctx.clip("evenodd");
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke(); ctx.restore();
        ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.clip();
        ctx.beginPath(); ctx.arc(ix, iy, ir, 0, Math.PI * 2); ctx.stroke(); ctx.restore();
        var stx = cx + R * 0.6, sty = cy - R * 0.28, sr = R * 0.12;
        ctx.fillStyle = foil; ctx.beginPath();
        for (var q = 0; q < 8; q++) { var qa = q * Math.PI / 4 - Math.PI / 2, qr = q % 2 ? sr * 0.28 : sr; ctx.lineTo(stx + qr * Math.cos(qa), sty + qr * Math.sin(qa)); }
        ctx.closePath(); ctx.fill();
      } else if (shape === "planete") {
        ctx.lineWidth = lwIn; shapePath(ctx, shape, cx, cy, R + g1); ctx.stroke();
        ctx.save(); ctx.translate(cx, cy); ctx.rotate(-0.32);
        ctx.lineWidth = lwIn * 1.2; ctx.beginPath(); ctx.ellipse(0, 0, R * 1.22, R * 0.32, 0, 0, Math.PI, false); ctx.stroke();
        ctx.lineWidth = lwOut; ctx.beginPath(); ctx.ellipse(0, 0, R * 1.09, R * 0.25, 0, 0, Math.PI, false); ctx.stroke();
        ctx.restore();
      } else {
        ctx.lineWidth = lwIn; shapePath(ctx, shape, cx, cy, R * sc + g1); ctx.stroke();
        ctx.lineWidth = lwOut; ctx.globalAlpha = 0.6; shapePath(ctx, shape, cx, cy, R * sc * (shape === "etoile" ? 1.08 : 1) + g2); ctx.stroke(); ctx.globalAlpha = 1;
      }
      if (circleLike && orn !== "fin") drawOrnament(ctx, orn, cx, cy, R, foil, W, { g1: g1, g2: g2, lwOut: lwOut, monthIdx: monthIdx, bodyFam: F.body });
      if (signInfo) drawZodiacEmblem(ctx, cx, cy, R, signInfo, LK.ring);

      /* textes */
      ctx.save(); drawText(); ctx.restore();

      /* finition reflets : par-dessus tout le dessin sur papier sombre (effet vitre) */
      if (dark && finish !== "laque") drawFinish(ctx, W, H, true, finish);
    }
    function posterRatio() { var c = SIZE_CM[state.size] || [30, 40]; return c[1] / c[0]; }
    function renderPoster(pc) { if (pc && state.skyReady) paintPosterTo(pc, canvas, true); }
    function paintPoster() {
      if (!posterCanvas) return;
      var w = Math.min(1000, Math.max(560, Math.floor(posterCanvas.parentElement.offsetWidth || 420) * Math.min(window.devicePixelRatio || 1, 2)));
      posterCanvas.width = w; posterCanvas.height = Math.round(w * posterRatio());
      renderPoster(posterCanvas);
    }
    /* Fichier d'impression : 300 DPI visés, plafonné à ~60 Mpx (grands posters ≈ 230-260 DPI) pour rester fiable dans le navigateur. */
    function hdDpi() { var c = SIZE_CM[state.size] || [30, 40]; var px = (c[0] / 2.54) * (c[1] / 2.54); return Math.max(150, Math.min(300, Math.floor(Math.sqrt(60e6 / px)))); }
    function hdSize() { var c = SIZE_CM[state.size] || [30, 40], dpi = hdDpi(); return [Math.round(c[0] / 2.54 * dpi), Math.round(c[1] / 2.54 * dpi)]; }
    function previewImage() {
      return new Promise(function (resolve) {
        var pv = document.createElement("canvas"); pv.width = 640; pv.height = Math.round(640 * posterRatio());
        paintPosterTo(pv, canvas, true);
        var d = hdSize();
        resolve({ preview: pv.toDataURL("image/jpeg", 0.8), px: d[0] + " × " + d[1] + " px (" + hdDpi() + " dpi)" });
      });
    }
    function hdImages() {
      return new Promise(function (resolve) {
        var hdSky = document.createElement("canvas"), d0 = hdSize();
        var skyPx = Math.max(3000, Math.min(6000, Math.round(d0[0] * 0.95)));
        hdSky.width = skyPx; hdSky.height = skyPx;
        draw(hdSky, currentOpts(), function () {
          var hd = document.createElement("canvas"), d = hdSize();
          hd.width = d[0]; hd.height = d[1];
          paintPosterTo(hd, hdSky);
          var pv = document.createElement("canvas"); pv.width = 640; pv.height = Math.round(640 * posterRatio());
          paintPosterTo(pv, hdSky, true);
          /* JPEG qualité 0,95 (Blob) : un PNG de cette taille dépasserait souvent 50 Mo et toDataURL peut échouer. */
          hd.toBlob(function (blob) {
            resolve({ poster: blob ? URL.createObjectURL(blob) : hd.toDataURL("image/jpeg", 0.95), preview: pv.toDataURL("image/jpeg", 0.8), px: d[0] + " × " + d[1] + " px (" + hdDpi() + " dpi)" });
          }, "image/jpeg", 0.95);
        });
      });
    }

    /* --- Rendu du ciel + enchaînement affiche --- */
    var currentOpts = function () {
      return { date: dateI && dateI.value, time: timeI && timeI.value, location: locI && locI.value, look: style.palette, sky: style.sky, dens: style.dens, lines: style.lines };
    };
    var render = function () {
      draw(canvas, currentOpts(), function (coords, precise) {
        state.coords = coords;
        state.locOk = !!precise;
        if (window.celestiarRevalidate) window.celestiarRevalidate();
        state.skyReady = true;
        paintPoster();
      });
    };
    var t;
    [dateI, timeI, locI].forEach(function (i) {
      if (i) i.addEventListener("input", function () {
        if (i === locI) { state.locOk = undefined; if (window.celestiarRevalidate) window.celestiarRevalidate(); }
        clearTimeout(t); t = setTimeout(render, 250);
      });
    });
    window.celestiarSkyLocation = function () { return state.locOk; };
    /* Affiche en haute définition pour l’aperçu « Voir chez moi » (texte net même en zoom). */
    window.celestiarSkyArt = function (w) { var c = document.createElement("canvas"); c.width = w; c.height = Math.round(w * posterRatio()); renderPoster(c); return c; };
    [prenomI, phraseI].forEach(function (i) {
      if (i) i.addEventListener("input", function () {
        if (i === phraseI && phraseCounter) phraseCounter.textContent = i.value.length + "/60";
        if (state.skyReady) renderPoster(posterCanvas);
      });
    });

    var q = new URLSearchParams(window.location.search);
    if (q.get("date") && dateI) dateI.value = q.get("date");
    if (q.get("heure") && timeI) timeI.value = q.get("heure");
    if (q.get("lieu") && locI) locI.value = q.get("lieu");
    if (q.get("prenom") && prenomI) prenomI.value = q.get("prenom").slice(0, 40);
    if (q.get("phrase") && phraseI) { phraseI.value = q.get("phrase").slice(0, 60); if (phraseCounter) phraseCounter.textContent = phraseI.value.length + "/60"; }
    var pickParam = function (attr, val) {
      var b = val && document.querySelector("[" + attr + '="' + String(val).replace(/[^a-z0-9_-]/gi, "") + '"]');
      if (b) b.click();
    };
    pickParam("data-frame", q.get("cadre"));
    var sizeKey = function (s) { return String(s || "").replace(/\s*cm\s*/i, "").replace(/\s*[×x]\s*/i, "x").trim(); };
    if (q.get("taille")) {
      var sizeBtn = Array.prototype.filter.call(document.querySelectorAll("[data-size]"), function (b) { return sizeKey(b.dataset.size) === sizeKey(q.get("taille")); })[0];
      if (sizeBtn) sizeBtn.click();
    }

    /* ---- Options de personnalisation : un seul mecanisme pour tout (boutons data-sky-*) ---- */
    var OPTS = [["data-sky-shape", "shape"], ["data-sky-bg", "bg"], ["data-sky-palette", "palette"], ["data-sky-ciel", "sky"], ["data-sky-finish", "finish"],
      ["data-sky-font", "font"], ["data-sky-layout", "layout"], ["data-sky-border", "border"], ["data-sky-dens", "dens"], ["data-sky-lines", "lines"], ["data-sky-datefmt", "datefmt"]];
    var ATTR = {}; OPTS.forEach(function (o) { ATTR[o[1]] = o[0]; });
    var SKYKEYS = { palette: 1, sky: 1, dens: 1, lines: 1 };   /* ces options changent le dessin du ciel lui-meme */
    var batching = false;
    function markOpt(key, val) {
      var attr = ATTR[key];
      document.querySelectorAll("[" + attr + "]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute(attr) === val); });
      style[key] = val;
    }
    function afterChange(key, skyChanged) {
      if (batching) return;
      if (skyChanged || SKYKEYS[key]) { ensureFonts(function () { render(); }); return; }
      ensureFonts(function () { if (state.skyReady) renderPoster(posterCanvas); });
    }
    OPTS.forEach(function (cfg) {
      document.querySelectorAll("[" + cfg[0] + "]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          markOpt(cfg[1], btn.getAttribute(cfg[0]));
          document.querySelectorAll("[data-sky-preset]").forEach(function (pb) { pb.classList.remove("is-selected"); });
          var skyChanged = false;
          /* un ciel blanc ne se lit que sur un papier clair (et inversement) : on aligne l'autre reglage */
          if (cfg[1] === "sky" && style.sky === "blanc" && BGS[style.bg].dark) markOpt("bg", "blanc");
          if (cfg[1] === "bg" && BGS[style.bg].dark && style.sky === "blanc") { markOpt("sky", "noir"); skyChanged = true; }
          afterChange(cfg[1], skyChanged);
        });
      });
    });
    [headI, coordI].forEach(function (el) { if (el) el.addEventListener(el.type === "checkbox" ? "change" : "input", function () { if (state.skyReady) paintPoster(); }); });

    /* Collections « Signature » Celestiar : un clic regle papier, ciel, couleurs, typographie, mise en page et bordure. */
    var SIGNATURES = {
      "minuit-or":           { bg: "noir", sky: "noir", palette: "or", finish: "laque", font: "elegance", layout: "classique", border: "fin", dens: "normale", lines: "fins", datefmt: "texte" },
      "aube-nacree":         { bg: "blanc", sky: "blanc", palette: "or", finish: "laque", font: "elegance", layout: "classique", border: "fin", dens: "normale", lines: "fins", datefmt: "texte" },
      "bleu-roi":            { bg: "noir", sky: "bleu", palette: "or", finish: "laque", font: "elegance", layout: "classique", border: "fin", dens: "normale", lines: "fins", datefmt: "texte" },
      "etoile-pur":          { bg: "blanc", sky: "noir", palette: "etoile", finish: "laque", font: "elegance", layout: "classique", border: "fin", dens: "normale", lines: "fins", datefmt: "texte" },
      "foret-emeraude":      { bg: "foret", sky: "noir", palette: "emeraude", finish: "aurore", font: "editorial", layout: "classique", border: "rayons", dens: "riche", lines: "fins", datefmt: "texte" },
      "rubis-royal":         { bg: "bordeaux", sky: "noir", palette: "rubis", finish: "eclat", font: "deco", layout: "titre", border: "boussole", dens: "normale", lines: "fins", datefmt: "texte" },
      "cuivre-orion":        { bg: "ardoise", sky: "noir", palette: "cuivre", finish: "vitre", font: "moderne", layout: "minimal", border: "fin", dens: "riche", lines: "marques", datefmt: "chiffres" },
      "glacier-polaire":     { bg: "nuit", sky: "bleu", palette: "glacier", finish: "voile", font: "moderne", layout: "classique", border: "mois", dens: "normale", lines: "fins", datefmt: "texte" },
      "sable-etoile":        { bg: "sable", sky: "blanc", palette: "cuivre", finish: "laque", font: "manuscrit", layout: "titre", border: "lune", dens: "legere", lines: "fins", datefmt: "lettres" },
      "amethyste-imperiale": { bg: "noir", sky: "noir", palette: "amethyste", finish: "aurore", font: "romantique", layout: "minimal", border: "fin", dens: "normale", lines: "fins", datefmt: "romain" },
      "duo-etoile":          { shape: "cercle", bg: "nuit", sky: "bleu", palette: "argent", finish: "voile", font: "romantique", layout: "titre", border: "boussole", dens: "normale", lines: "fins", datefmt: "texte" },
      "nos-deux-astres":     { shape: "cercle", bg: "prune", sky: "noir", palette: "rose", finish: "aurore", font: "manuscrit", layout: "titre", border: "lune", dens: "riche", lines: "fins", datefmt: "lettres" },
      "premiere-lune":       { shape: "cercle", bg: "azur", sky: "blanc", palette: "glacier", finish: "laque", font: "manuscrit", layout: "titre", border: "lune", dens: "legere", lines: "fins", datefmt: "lettres" },
      "petite-etoile":       { shape: "etoile", bg: "rose", sky: "blanc", palette: "rose", finish: "laque", font: "romantique", layout: "titre", border: "fin", dens: "legere", lines: "fins", datefmt: "texte" },
      "alliance-or":         { shape: "cercle", bg: "blanc", sky: "blanc", palette: "or", finish: "laque", font: "romantique", layout: "classique", border: "couronne", dens: "legere", lines: "fins", datefmt: "romain" },
      "nuit-de-noces":       { shape: "cercle", bg: "nuit", sky: "bleu", palette: "or", finish: "eclat", font: "elegance", layout: "classique", border: "couronne", dens: "normale", lines: "fins", datefmt: "texte" },
      "rouge-passion":       { shape: "cercle", bg: "bordeaux", sky: "noir", palette: "rose", finish: "eclat", font: "romantique", layout: "titre", border: "coeurs", dens: "normale", lines: "fins", datefmt: "texte" },
      "coeur-de-minuit":     { shape: "coeur", bg: "noir", sky: "noir", palette: "rubis", finish: "laque", font: "manuscrit", layout: "titre", border: "fin", dens: "riche", lines: "fins", datefmt: "lettres" },
      "nuit-de-noel":        { shape: "cercle", bg: "foret", sky: "noir", palette: "or", finish: "eclat", font: "elegance", layout: "classique", border: "guirlande", dens: "riche", lines: "fins", datefmt: "texte" },
      "sapin-etoile":        { shape: "sapin", bg: "bordeaux", sky: "noir", palette: "or", finish: "eclat", font: "editorial", layout: "titre", border: "fin", dens: "riche", lines: "fins", datefmt: "texte" },
      "grande-fete":         { shape: "cercle", bg: "prune", sky: "noir", palette: "or", finish: "eclat", font: "deco", layout: "titre", border: "guirlande", dens: "riche", lines: "fins", datefmt: "chiffres" },
      "bulles-champagne":    { shape: "cercle", bg: "sable", sky: "blanc", palette: "or", finish: "laque", font: "manuscrit", layout: "titre", border: "guirlande", dens: "legere", lines: "fins", datefmt: "lettres" },
      "etoile-eternelle":    { shape: "cercle", bg: "ardoise", sky: "noir", palette: "argent", finish: "voile", font: "elegance", layout: "minimal", border: "lune", dens: "normale", lines: "fins", datefmt: "texte" },
      "souvenir-blanc":      { shape: "cercle", bg: "blanc", sky: "blanc", palette: "argent", finish: "soie", font: "editorial", layout: "classique", border: "couronne", dens: "legere", lines: "fins", datefmt: "texte" }
    };
    var PRESET_ALIAS = { "or-noir": "minuit-or", "or-blanc": "aube-nacree", "bleu-or": "bleu-roi", "etoile": "etoile-pur" };
    function applyConfig(cfg) {
      batching = true;
      Object.keys(cfg).forEach(function (k) { if (ATTR[k]) markOpt(k, cfg[k]); });
      batching = false;
      ensureFonts(function () { render(); });
    }
    function applyPreset(id) {
      var key = SIGNATURES[id] ? id : PRESET_ALIAS[id], cfg = SIGNATURES[key]; if (!cfg) return;
      applyConfig(cfg);
      document.querySelectorAll("[data-sky-preset]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-sky-preset") === key); });
    }
    document.querySelectorAll("[data-sky-preset]").forEach(function (b) { b.addEventListener("click", function () { applyPreset(b.getAttribute("data-sky-preset")); }); });
    window.celestiarSkyPreset = applyPreset;

    /* parametres du lien de partage */
    pickParam("data-sky-shape", q.get("forme"));
    if (brandI && q.get("titre") === "0") brandI.checked = false;
    if (brandI) brandI.addEventListener("change", function () { if (state.skyReady) paintPoster(); });
    var urlKeys = { fond: "data-sky-bg", palette: "data-sky-palette", ciel: "data-sky-ciel", finition: "data-sky-finish", police: "data-sky-font", miseenpage: "data-sky-layout", bordure: "data-sky-border", densite: "data-sky-dens", traits: "data-sky-lines", datefmt: "data-sky-datefmt" };
    var anyUrlStyle = false;
    Object.keys(urlKeys).forEach(function (k) { if (q.get(k)) { anyUrlStyle = true; pickParam(urlKeys[k], q.get(k)); } });
    if (q.get("signature") && SIGNATURES[q.get("signature")]) { anyUrlStyle = true; applyPreset(q.get("signature")); }
    if (q.get("titrehaut") && headI) headI.value = q.get("titrehaut").slice(0, 26);
    if (q.get("coords") === "1" && coordI) coordI.checked = true;
    if (!anyUrlStyle) applyPreset("minuit-or");
    var sug = document.querySelector("[data-sky-suggest]"), sugT;
    if (locI && sug) {
      locI.addEventListener("input", function () {
        clearTimeout(sugT);
        var v = locI.value.trim();
        if (v.length < 3) { sug.hidden = true; return; }
        sugT = setTimeout(function () {
          fetch("https://photon.komoot.io/api/?limit=6&lang=" + (lang === "en" ? "en" : "fr") + "&osm_tag=place:city&osm_tag=place:town&osm_tag=place:village&osm_tag=place:hamlet&q=" + encodeURIComponent(v))
            .then(function (r) { return r.json(); })
            .then(function (res) {
              sug.innerHTML = "";
              ((res && res.features) || []).forEach(function (f, k) {
                var pr = f.properties || {}, it = { lat: f.geometry.coordinates[1], lon: f.geometry.coordinates[0] };
                var li = document.createElement("li");
                li.tabIndex = 0; li.setAttribute("data-testid", "sky-location-suggestion-" + k);
                li.textContent = [pr.name, pr.state, pr.country].filter(Boolean).join(", ");
                var pick = function () {
                  locI.value = li.textContent;
                  window.CelestiarSky.pick(locI.value, parseFloat(it.lat), parseFloat(it.lon));
                  sug.hidden = true; state.locOk = undefined; render();
                };
                li.addEventListener("click", pick);
                li.addEventListener("keydown", function (e) {
                  if (e.key === "Enter") { e.preventDefault(); pick(); }
                  else if (e.key === "ArrowDown") { e.preventDefault(); (li.nextElementSibling || sug.firstElementChild).focus(); }
                  else if (e.key === "ArrowUp") { e.preventDefault(); (li.previousElementSibling || locI).focus(); }
                  else if (e.key === "Escape") { sug.hidden = true; locI.focus(); }
                });
                sug.appendChild(li);
              });
              sug.hidden = !sug.children.length;
            }).catch(function () { sug.hidden = true; });
        }, 400);
      });
      locI.addEventListener("keydown", function (e) {
        if (sug.hidden || !sug.children.length) return;
        var items = Array.prototype.slice.call(sug.children);
        var cur = items.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); (items[cur + 1] || items[0]).focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); (items[cur - 1] || items[items.length - 1]).focus(); }
        else if (e.key === "Enter") { e.preventDefault(); items[0].click(); }
        else if (e.key === "Escape") { sug.hidden = true; }
      });
      document.addEventListener("click", function (e) { if (e.target !== locI && !sug.contains(e.target)) sug.hidden = true; });
    }
    window.addEventListener("load", render);
    window.addEventListener("resize", function () { if (state.skyReady) paintPoster(); });
    render();
    updatePrice();

    /* --- Lien qui recrée exactement ce design (partage + commande) --- */
    function designUrl() {
      var sp = new URLSearchParams();
      [["date", dateI], ["heure", timeI], ["lieu", locI], ["prenom", prenomI], ["phrase", phraseI]].forEach(function (f) { if (f[1] && f[1].value) sp.set(f[0], f[1].value); });
      sp.set("forme", style.shape); sp.set("fond", style.bg); sp.set("palette", style.palette); sp.set("ciel", style.sky); sp.set("finition", style.finish);
      sp.set("police", style.font); sp.set("miseenpage", style.layout); sp.set("bordure", style.border); sp.set("densite", style.dens); sp.set("traits", style.lines); sp.set("datefmt", style.datefmt);
      if (headI && headI.value.trim()) sp.set("titrehaut", headI.value.trim()); if (coordI && coordI.checked) sp.set("coords", "1");
      if (state.size) sp.set("taille", String(state.size).replace(/\s*cm\s*/i, "").replace(/\s*×\s*/, "x"));
      if (state.frame) sp.set("cadre", state.frame);
      if (brandI && !brandI.checked) sp.set("titre", "0");
      return window.location.origin + window.location.pathname + "?" + sp.toString();
    }
    window.celestiarDesignUrl = designUrl;

    /* --- Export HD réservé à la boutique : ouvrir le « lien de recréation » d'une commande avec &export=1 --- */
    if (new URLSearchParams(window.location.search).get("export") === "1") {
      var xb = document.createElement("button");
      xb.type = "button"; xb.textContent = "Exporter l'affiche HD (boutique)";
      xb.style.cssText = "position:fixed;left:16px;bottom:16px;z-index:99999;padding:12px 18px;border-radius:999px;border:1px solid #e8d5a3;background:#0b0d1a;color:#f4e8c1;font:600 14px sans-serif;cursor:pointer";
      document.body.appendChild(xb);
      var sha = function (s) {
        return crypto.subtle.digest("SHA-256", new TextEncoder().encode(s)).then(function (b) {
          return Array.prototype.map.call(new Uint8Array(b), function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
        });
      };
      xb.addEventListener("click", function () {
        var p = window.prompt("Mot de passe boutique :");
        if (!p) return;
        sha(p).then(function (h) {
          if (h !== "242c9cf445519186e5f26876265c89d7497b1ec799013bebc42c379df05258ea") { window.alert("Mot de passe incorrect."); return; }
          if (!state.skyReady) { window.alert("Le ciel est encore en cours de calcul, réessayez dans un instant."); return; }
          xb.textContent = "Création du fichier…";
          hdImages().then(function (imgs) {
            var a = document.createElement("a");
            a.href = imgs.poster; a.download = "celestiar-affiche-hd-" + (prenomI && prenomI.value ? prenomI.value.replace(/[^a-z0-9]+/gi, "-") : "commande") + "-" + String(state.size || "").replace(/[^0-9x×]+/g, "").replace("×", "x") + ".jpg";
            document.body.appendChild(a); a.click(); a.remove();
            xb.textContent = "Exporter l'affiche HD (boutique)";
          });
        });
      });
    }

    /* --- Liens secondaires --- */
    if (shareBtn) {
      shareBtn.addEventListener("click", function () {
        var url = designUrl();
        var done = function () {
          if (window.celestiarToast) window.celestiarToast(shareBtn.dataset.toast || "Lien copié — offrez ce ciel exact");
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done);
        else window.prompt("Copiez ce lien :", url);
      });
    }

    /* --- Étape 5 : ajout au panier avec images HD --- */
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var prenom = prenomI ? prenomI.value.trim() : "";
        var date = dateI ? dateI.value : "";
        var heure = timeI ? timeI.value : "";
        var lieu = locI ? locI.value.trim() : "";
        var phrase = phraseI ? phraseI.value.trim() : "";
        if (window.celestiarRevalidate && !window.celestiarRevalidate(true)) {
          showError((window.CELESTIAR_I18N && window.CELESTIAR_I18N.form_error) || "Complétez le prénom, la date, l'heure, la ville et la vérification de l'orthographe.");
          return;
        }
        if (!prenom || !date || !heure || !lieu || !(spellingI && spellingI.checked)) {
          showError((window.CELESTIAR_I18N && window.CELESTIAR_I18N.form_error) || "Complétez le prénom, la date, l'heure, la ville et la vérification de l'orthographe.");
          return;
        }
        if (!state.locOk || !state.coords || !state.coords.tz) {
          showError(lang === "en" ? "Place not found or time zone unavailable: check the spelling or pick a suggested place, then try again." : "Lieu introuvable ou fuseau horaire indisponible : vérifiez l'orthographe ou choisissez un lieu proposé, puis réessayez.");
          return;
        }
        if (!state.variantId) {
          showError((window.CELESTIAR_I18N && window.CELESTIAR_I18N.combo_error) || "Cette combinaison est indisponible.");
          return;
        }
        showError("");
        addBtn.disabled = true;
        addBtn.setAttribute("aria-busy", "true");
        var original = addLabel.textContent;
        addLabel.textContent = addBtn.dataset.creating || "Création de votre affiche haute définition…";

        var hdFiles = { px: "", preview: null };
        previewImage()
          .then(function (imgs) {
            hdFiles.px = imgs.px;
            return fetch(imgs.preview).then(function (r) { return r.blob(); });
          })
          .then(function (blob) {
            hdFiles.preview = blob;
            var props = {
              "Prénom": prenom,
              "Date": fmtDate(date),
              "Heure": heure,
              "Ville": lieu,
              "Phrase": phrase || "—",
              "Taille": state.size,
              "Cadre": state.support === "poster" ? "Poster seul (sans cadre)" : (state.frame === "chene" ? "Chêne" : (state.frame === "blanc" ? "Blanc" : "Noir")),
              "Coordonnées": state.coords ? (state.coords.lat.toFixed(4) + ", " + state.coords.lng.toFixed(4)) : "",
              "Orthographe vérifiée": "Oui",
              "Titre CELESTIAR en haut": (brandI && !brandI.checked) ? "Non" : "Oui",
              "Forme": ({ cercle: "Cercle", coeur: "Cœur", etoile: "Étoile", croissant: "Croissant de lune", orbe: "Orbe / perle", planete: "Planète à anneau", goutte: "Goutte", ovale: "Ovale", initiale: "Initiale du prénom", signe: "Constellation du signe", arche: "Arche", hexagone: "Hexagone", sapin: "Sapin" })[style.shape],
              "Fond": (BGS[style.bg] || BGS.noir).name,
              "Typographie": (FONTS[style.font] || FONTS.elegance).name,
              "Mise en page": ({ classique: "Classique", titre: "Le prénom en tête", minimal: "Minimal" })[style.layout] || "Classique",
              "Bordure": ({ fin: "Filets fins", graduations: "Graduations", rayons: "Rayons", lune: "Phases de lune", mois: "Roue des mois", boussole: "Boussole", guirlande: "Guirlande étoilée", coeurs: "Cœurs", couronne: "Couronne de laurier" })[style.border] || "Filets fins",
              "Étoiles": ({ legere: "Légère", normale: "Normale", riche: "Riche" })[style.dens] || "Normale",
              "Traits des constellations": ({ aucun: "Aucun", fins: "Fins", marques: "Marqués" })[style.lines] || "Fins",
              "Format de la date": ({ texte: "Date écrite (mois en lettres)", chiffres: "Chiffres", romain: "Chiffres romains", lettres: "En toutes lettres" })[style.datefmt] || "Texte",
              "Coordonnées affichées": (coordI && coordI.checked) ? "Oui" : "Non",
              "Titre du haut": (headI && headI.value.trim()) || "CELESTIAR",
              "Couleur du ciel": ({ bleu: "Bleu", blanc: "Blanc" })[style.sky] || "Noir",
              "Finition": ({ laque: "Laqué", vitre: "Vitre", eclat: "Éclat", aurore: "Aurore", voile: "Voile de lumière", soie: "Soie" })[style.finish] || "Laqué",
              "Palette": ({ etoile: "Étoilé", or: "Doré", argent: "Argent", rose: "Rose poudré", nuit: "Bleu nuit", cuivre: "Cuivre", emeraude: "Émeraude", amethyste: "Améthyste", glacier: "Glacier", rubis: "Rubis" })[style.palette],
              "Fuseau horaire": (state.coords && state.coords.tz) || "",
              "_Résolution HD": hdFiles.px || "",
              "_Lien de recréation": designUrl(),
              "_origine": "creez-votre-ciel"
            };
            if (style.shape === "signe") { var zs = zodiacFor(date, "fr"); if (zs) props["Signe astrologique"] = zs.name; }
            var fd = new FormData();
            fd.append("form_type", "product");
            fd.append("id", String(state.variantId));
            fd.append("quantity", "1");
            Object.keys(props).forEach(function (k) { fd.append("properties[" + k + "]", props[k]); });
            fd.append("properties[_Aperçu]", hdFiles.preview, "celestiar-apercu.jpg");
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
              body: fd
            }).then(function (r) {
              if (!r.ok) throw new Error("cart");
              return r.json();
            });
          })
          .then(function () {
            if (window.celestiarToast) window.celestiarToast(addBtn.dataset.added || "Votre ciel rejoint le panier.");
            window.location.href = ((window.CELESTIAR_I18N||{}).root||"/").replace(/\/$/,"") + "/cart";
          })
          .catch(function () {
            showError(addBtn.dataset.genericError || "Une interférence a empêché l'ajout au panier — réessayez dans un instant.");
            addBtn.removeAttribute("aria-busy");
            addBtn.disabled = false;
            addLabel.textContent = original;
            if (window.celestiarRevalidate) window.celestiarRevalidate();
          });
      });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();


